import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
// import Form from "react-bootstrap/Form";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import Accordion from "react-bootstrap/Accordion";
// import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { InputSwitch } from "primereact/inputswitch";
import { Dialog } from "primereact/dialog";
import format from "date-fns/format";
import { InputTextarea } from "primereact/inputtextarea";
// import { FileUpload } from "primereact/fileupload";

import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Axios from "../../api/Axios";
import AxiosExcel from "../../api/Axios";
import storage from "../../Services/Storage";
import { useEffect } from "react";
import { useFormik } from "formik";
import Loader from "../../Components/Loader";
// import { useCustMasterContext } from "../../context/CustomerMasterContext";
// import { ToastContainer } from "react-toastify";
// import { toast } from "react-toastify";
// import format from "date-fns/format";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Fi from "react-icons/fi";
let latitude = "";
let longitude = "";
import "./NewCustomer.css"; //for red error color only.
import { initialValues } from "../../Validations/NewCustomerValidation";
import SegmentModalNewCust from "./SegmentModalNewCust";
import * as Fa from "react-icons/fa";
import {
    createAPICustomerMastEndpoint,
    Endpoint,
} from "../../Services/CustomerMast/CustomerMastService";
const GetPaymentTerm_URL = "CustomerMast/GetPaymentTerm?";
const GetModeOfPayment_URL = "CustomerMast/GetModeOfPayment?";
const GetTaxEnvSettings_URL = "CustomerMast/GetTaxEnvSettings?";
const GetTaxArea_URL = "CustomerMast/GetTaxArea?";
const GetTaxForm_URL = "CustomerMast/GetTaxForm?";
const GetDistEmployee_URL = "CustomerMast/GetDistEmployee?";
const GetFrequency_URL = "CustomerMast/GetFrequency?";
const GetDayOfWeek_URL = "CustomerMast/GetDayOfWeek?";
const GetVanRoute_URL = "CustomerMast/GetVanRoute?";
const GetCompState_URL = "CustomerMast/GetCompState?";

function NewCustomer() {
    const [searchParam] = useSearchParams();
    let grid = searchParam.get("id");
    const auth = storage.getLocal("user");
    const [paymentTerm, setPaymentTerm] = useState([]);
    const [modeOfPayment, setModeOfPayment] = useState([]);
    const [taxArea, setTaxArea] = useState([]);
    const [taxForm, setTaxForm] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [beatFrequency, setBeatFrequency] = useState([]);
    const [dayOfWeek, setDayOfWeek] = useState([]);
    const [nameStatus, setNameStatus] = useState(false);
    const [segStatus, setsegStatus] = useState(false);
    //   const [expiryStatus, setexpiryStatus] = useState(false);
    //   const [uniqueStatus, setuniqueStatus] = useState(false);
    const [fnameStatus, setFnameStatus] = useState(false);
    const [lnameStatus, setLnameStatus] = useState(false);
    const [address1Status, setAddress1Status] = useState(false);
    const [address2Status, setAddress2Status] = useState(false);
    const [townStatus, setTownStatus] = useState(false);
    const [creditHoldStatus, setCreditHoldStatus] = useState(false);
    const [paymentTermStatus, setPaymentTermStatus] = useState(false);
    const [taxAreaStatus, setTaxAreaStatus] = useState(false);
    const [paymentModeStatus, setPaymentModeStatus] = useState(false);
    // const [invoiceCopyStatus, setInvoiceCopyStatus] = useState(false);
    const [tradeDiscStatus, setTradeDiscStatus] = useState(false);
    const [preferedDayStatus, setPreferedDayStatus] = useState(false);
    const [address1Status1, setAddress1Status1] = useState(false);
    const [mobverifiedtag, setMobverifiedtag] = useState(false);
    const [townStatus1, setTownStatus1] = useState(false);
    // const [vanRouteStatus, setVanRouteStatus] = useState(false);
    const [fnameStatus1, setFnameStatus1] = useState(false);
    const [lnameStatus1, setLnameStatus1] = useState(false);
    const [mobileStatus, setMobileStatus] = useState(false);
    const [mobileStatus1, setMobileStatus1] = useState(false);
    const [gstverifiedtag, setGstverifiedtag] = useState(false);
    const [disabledbtn, setDisabledbtn] = useState(false);
    const [gstcustdetailsseparated, setGstcustdetailsseparated] = useState("");
    const [panverifysuccess, setPanverifysuccess] = useState(false);
    const [rsechecked,setRseChecked] = useState(false);
    const [loaderpan, setLoaderpan] = useState(false);

    let taxEnvSettings = "";
    const [vanRoute, setVanRoute] = useState([]);
    const [pandataverify, setPandataverify] = useState([]);

    //   const [tinStatus, setTinStatus] = useState(false);
    const [pannoStatus, setPannoStatus] = useState(false);
    const [gstnoStatus, setGstnoStatus] = useState(false);

    const [prefixStatus, setPrefixStatus] = useState(false);
    const [midnameStatus, setMidnameStatus] = useState(false);
    const [phnoStatus, setPhnoStatus] = useState(false);
    const [cemailStatus, setCemailStatus] = useState(false);
    const [creditlimStatus, setCreditlimStatus] = useState(false);
    const [minorderStatus, setMinorderStatus] = useState(false);
    const [maxorderStatus, setMaxorderStatus] = useState(false);
    const [transchrgStatus, setTranschrgStatus] = useState(false);
    const [priortyStatus, setPriortyStatus] = useState(false);
    const [delvinsStatus, setDelvinsStatus] = useState(false);
    const [billinsStatus, setBillinsStatus] = useState(false);
    const [shipaddStatus, setShipaddStatus] = useState(false);
    const [shipgstStatus, setShipgstStatus] = useState(false);
    const [stitleStatus, setStitleStatus] = useState(false);
    const [smidnameStatus, setSmidnameStatus] = useState(false);
    const [sphnumStatus, setSphnumStatus] = useState(false);
    const [shipemailStatus, setShipemailStatus] = useState(false);
    const [fullcustimgpPopup, setFullcustimgpPopup] = useState(false);
    const [fulliIdPopup, setFullIdPopup] = useState(false);
    const [phoneValidationPopUp, setPhoneValidationPopUp] = useState(false);
    const [customerDetailsData, setCustomerDetailsData] = useState([]);
    //   const [newCustomerSave, setNewCustomerSave] = useState(false);
    // const [kycstatus, setKycstatus] = useState(false);
    const [customerDetailsById, setCustomerDetailsById] = useState([]);
    const [creationDate, setCreationdate] = useState([]);

    //-------------------------------
    const [customerDetailsByIdGST, setCustomerDetailsByIdGST] = useState([]);
    const [compState, setCompState] = useState("");
    // const [taxenv, setTaxenv] = useState("");
    const [townList, setTownList] = useState([]);
    const [editCustMastLoader, setEditCustMastLoader] = useState(false);
    const [loader, setLoader] = useState(false);
    // const [creationDate, setCreationdate] = useState([]);
    const [expiryDate, setExpiryDate] = useState([]);
    //   const [townInput, setTownInput] = useState(0);
    const [townSuggestion, setTownSuggestion] = useState(null);
    const [shipTownSuggestion, setShipTownSuggestion] = useState([]);
    const [billDistrict, setBillDistrict] = useState([]);
    // const [billTown, setBillTown] = useState([]);
    const [billState, setBillState] = useState([]);
    const [billZip, setBillZip] = useState("");
    const [manualTownEnter, setManualTownEnter] = useState(false);
    const [loadinfdt, setLoadinfdt] = useState(false);
    const [shipTownList, setShipTownList] = useState([]);
    const [shipSalesArea, setShipSalesArea] = useState([]);
    const [customerSaveUpdateLoader, setCustomerSaveUpdateLoader] =
    useState(false);
    const [partyCodeOnSave, setPartyCodeOnsave] = useState([]);
    // const [segmentConfirmBtn, setSegmentConfirmBtn] = useState(false);
    const [uniqueCodeBtn, setUniqueCodeBtn] = useState(false);
    // const [gstveridisable, setGstveridisable] = useState(false);
    // const [mobveridisable, setMobveridisable] = useState(false);
    //---------------------------shipping----------------------------------
    //   const [shipTown, setShipTown] = useState([]);
    const [shipDistrict, setShipDistrict] = useState([]);
    const [shipState, setShipState] = useState([]);
    const [shipZip, setShipZip] = useState([]);
    const [manualShipTownEnter, setManualShipEnter] = useState(false);
    const [custId, setCustId] = useState([]);
    // const [billAddressLoader, setBillAddressLoader] = useState(false);
    const [segmentPopup, setSegmentPopup] = useState(false);
    const [segmentStreamList, setSegmentStreamList] = useState([]);
    const [segmentForEdit, setSegmentForEdit] = useState([]);
    const [newCustomerSave, setNewCustomerSave] = useState(true);

    const [segmentValue, setSegmentValue] = useState([]);
    // const [shipTownError, setShipTownError] = useState(false);
    // const [shipTownInitailVal, setShipTownInitialVal] = useState(true);
    const [manualSegmentEnterBtn, setManualSegmentEnterBtn] = useState(false);
    const [newCutomerUniCode, setNewCustomerUniCode] = useState([]);
    const [customerSaveDisable, setCustomerSaveDisable] = useState(false);
    // const [savingLoading, setSavingLoading] = useState(false);
    // const [errorLabel, setErrorLable] = useState(false);
    // const [exportbtnpopup, setExportbtnpopup] = useState(false);
    const [copyToShip, setCopyToShip] = useState(false);
    const [kycStatus, setKycStatus] = useState(false);
    const [kycfieldDisabled, setKycfieldDisabled] = useState(false);
    const [kycfieldDisabledforHDILS, setKycfieldDisabledforHDILS] =
    useState(false);
    const [kycGSTfieldDisabledforHDILS, setKycGSTfieldDisabledforHDILS] =
    useState(false);
    const [dnaCustomerDetails, setDnaCustomerDetails] = useState([]);
    // const [dnaCustomerstatus, setDnaCustomerstatus] = useState(false);
    const [essrrliCustomerDetails, setEssrrliCustomerDetails] = useState([]);
    const [essrrliCuststatus, setEssrrliCuststatus] = useState(false);
    const [segmtPopup, setSegmtPopup] = useState(false);
    const [photoUploadftCS, setPhotoUploadftCS] = useState(false);
    const [photoUploadndviewCS, setPhotoUploadndviewCS] = useState(false);
    const [normalPhotoViewCS, setNormalPhotoViewCS] = useState(false);
    const [isB2bcust, setIsB2bcust] = useState(false);
    const [hdILScustomer, setHdILScustomer] = useState(false);
    const [phototabdisle, setPhototabdisle] = useState(false);
    const [statuserror, setStatuserror] = useState(false);
    const [gstrequedfield, setGstrequedfield] = useState(false);
    const [bsicmiddnamerequedfield, setBsicmiddnamerequedfield] = useState(false);
    const [basicadd2requedfield, setBasicadd2requedfield] = useState(false);
    const [basicmobrequedfield, setBasicmobrequedfield] = useState(false);
    const [shipadd2requedfield, setShipadd2requedfield] = useState(false);
    const [shipmiddnamerequedfield, setShipmiddnamerequedfield] = useState(false);
    const [shipmobnorequedfield, setShipmobnorequedfield] = useState(false);
    const [commentssectionvsble, setCommentssectionvsble] = useState(false);
    const [getHDDistStatus, setGetHDDistStatus] = useState();
    const [getcustImage, setGetcustImage] = useState();
    const [getstoreImage, setGetstoreImage] = useState();
    const [tcsDropDownlist, setTcsDropDownlist] = useState([]);
    const [gstCustomerDetails, setGstCustomerDetails] = useState([]);
    const [storeVerifydata, setStoreVerifydata] = useState([]);
    const [showTCSdropdown, setShowTCSdropdown] = useState(false);
    // const [bydefTCSval, setBydefTCSval] = useState();
    const [selectedTCS, setSelectedTCS] = useState(null);
    // const [segmentValue, setSegmentValue] = useState([]);
    const [searchparam] = useSearchParams();
    // /api/CustomerMast/GetCustImage
    const getCustomerDetailsById_URL = "CustomerMast/GetCustomerDetailsById?";
    const getCustomerphoto_URL = "CustomerMast/GetCustImage?";
    const town_URL = "CustomerMast/GetTown?";
    const ship_town_URL = "CustomerMast/GetShipTown?";
    const ship_town_URL_ILS = "CustomerMast/GetShipTownILS?";
    const zip_Search_URL = "CustomerMast/zipSearch?";
    const getCustomerInfoByCustId_URL = "CustomerMast/GetCustomerInfoByCustId?";
    const uniqueCodeGen_URL = "CustomerMast/UCode_AutoGen?";
    const hdddiststs_URL = "CustomerMast/GetHDDistStatus?";

    // credit hold DropDown
    const radioBtns_credit_hold = [
        { id: "1", name: "Yes", value: "Y" },
        { id: "2", name: "No", value: "N" },
    ];
    let nav = useNavigate();
    // console.log(auth);

    useEffect(() => {
        let OnpageLoad = async () => {
            // debugger;
            if (auth.DistTag === "I") {
                setHdILScustomer(true);
                setIsB2bcust(true);
                let diststsresponse = await Axios.get(
                    `${hdddiststs_URL}CompId=${auth.CompId}`,
                );
                setGetHDDistStatus(diststsresponse?.data);
                if (diststsresponse?.data === "Y") {
                    setCommentssectionvsble(true);
                    setGstrequedfield(true);
                    setBsicmiddnamerequedfield(true);
                    setBasicadd2requedfield(true);
                    setBasicmobrequedfield(true);
                    setShipadd2requedfield(true);
                    setShipmiddnamerequedfield(true);
                    setShipmobnorequedfield(true);
                    setStatuserror(false);
                }
            } else {
                setHdILScustomer(false);
            }
        };
        setSegmentValue([]);
        setNewCustomerUniCode([]);
        setLoader(false);
        OnpageLoad();
    }, []);

    //   console.log("getHDDistStatus", getHDDistStatus);

    const preferedDay = [
        { id: "1", name: "Sunday" },
        { id: "2", name: "Monday" },
        { id: "3", name: "Tuesday" },
        { id: "4", name: "Wednesday" },
        { id: "5", name: "Thursday" },
        { id: "6", name: "Friday" },
        { id: "7", name: "Saturday" },
    ];
    const customerMasterFun = async () => {
    //Call All APi
        try {
            setEditCustMastLoader(true);
            const GetCompState_api = `${GetCompState_URL}CompId=${auth.CompId}`;
            const GetPaymentTerm_api = `${GetPaymentTerm_URL}CICode=${auth.CICode}`;
            const GetModeOfPayment_api = `${GetModeOfPayment_URL}CICode=${auth.CICode}`;
            const GetTaxEnvSettings_api = `${GetTaxEnvSettings_URL}CICode=${auth.CICode}`;
            const GetTaxEnvSettingsRes = await Axios.get(GetTaxEnvSettings_api);
            taxEnvSettings = GetTaxEnvSettingsRes.data.TaxSettings.toString();
            const GetTaxArea_api = `${GetTaxArea_URL}CICode=${auth.CICode}&strExportable="Y"&strEnvOption=${taxEnvSettings}`;
            const GetTaxForm_api = `${GetTaxForm_URL}CICode=${auth.CICode}&strExportable="Y"&strEnvOption=${taxEnvSettings}&Country="N"`;
            const GetDistEmployee_api = `${GetDistEmployee_URL}CICode=${auth.CICode}&CompId=${auth.CompId}`;
            const GetFrequency_api = `${GetFrequency_URL}CICode=${auth.CICode}`;
            const GetDayOfWeek_api = `${GetDayOfWeek_URL}CICode=${auth.CICode}`;
            const GetVanRoute_api = `${GetVanRoute_URL}CICode=${auth.CICode}&CompId=${auth.CompId}`;
            const town_api = `${town_URL}CICode=${auth.CICode}&intGeogLevel=3`;
            const ship_town_api = `${
                auth.DistTag === "I" ? ship_town_URL_ILS : ship_town_URL
            }CICode=${auth.CICode}&intGeogLevel=3&CompId=${auth.CompId}`;
            const res = await Axios.get(GetCompState_api);
            const GetPaymentTermRes = await Axios.get(GetPaymentTerm_api);
            const GetModeOfPaymentRes = await Axios.get(GetModeOfPayment_api);
            const taxareaRes = await Axios.get(GetTaxArea_api);
            const taxFormRes = await Axios.get(GetTaxForm_api);
            const employeeRes = await Axios.get(GetDistEmployee_api);
            const FrequencyRes = await Axios.get(GetFrequency_api);
            const GetDayOfWeekRes = await Axios.get(GetDayOfWeek_api);
            const van_route_res = await Axios.get(GetVanRoute_api);
            const town_res = await Axios.get(town_api);
            const ship_town_res = await Axios.get(ship_town_api);

            let mappertown1 = town_res?.data.map((item) => ({
                ...item,
                TOWN_PIN: `${item.NAME} - ${item.PIN_CODE}`,
            }));
            setTownList(mappertown1);

            let mappertown = ship_town_res?.data.map((item) => ({
                ...item,
                TOWN_PIN_SHIP: `${item.TOWN} - ${item.PIN_CODE}`,
            }));
            setShipTownList(mappertown);
            // setTownList(mappertown1);
            // setShipTownList(ship_town_res?.data);
            setCompState(res?.data);
            setPaymentTerm(GetPaymentTermRes?.data);
            setModeOfPayment(GetModeOfPaymentRes?.data);
            setTaxArea(taxareaRes?.data);
            setTaxForm(taxFormRes?.data);
            setEmployeeList(employeeRes?.data);
            setBeatFrequency(FrequencyRes?.data);
            setDayOfWeek(GetDayOfWeekRes?.data);
            setVanRoute(van_route_res?.data);
            setEditCustMastLoader(false);
        } catch (error) {
            console.log(error);
            setEditCustMastLoader(false);
        }
    };
    let custIdparam = searchparam.get("maskCustId");
    let resType = searchparam.get("reseType");
    // console.log("custIdparam",custIdparam);
    let partyCodeparam = searchparam.get("partyCode");
    // console.log("partyCode",partyCode);
    let customerType = searchparam.get("custType");
    let dnaListcustId = searchparam.get("dnaId");
    let essrrlicustId = searchparam.get("essrrliID");
    let getGstcustId = searchparam.get("gstcustId");
    let getGstcustcode = searchparam.get("gstcustcode");
    let getrowdatagst = searchparam.get("rowdatagst");
    let ismobcustid = searchparam.get("ismobcust");
    // console.log("customerType", customerType);
    useEffect(() => {
        if (customerType == "newcust") {
            customerMasterFun();
            getSegmentForBill();
            setPhototabdisle(true);
            // if(auth.EInvApplicability=="Y"){
            //     setGstrequedfield(true);
            // }else{
            //     setGstrequedfield(false);
            // }
        } else if (
            customerType == "normal" &&
      partyCodeparam !== null &&
      custIdparam !== null
        ) {
            viewCustomerDetails(custIdparam, partyCodeparam);
            tcsappchk(custIdparam);
            setSegmtPopup(true);
            customerMasterFun();
            setPhototabdisle(false);
        } else if (customerType == "RLIESSR" && essrrlicustId !== null) {
            EssrRLIcustomerList(essrrlicustId);
            setEssrrliCuststatus(true);
            setSegmtPopup(true);
            customerMasterFun();
            setPhototabdisle(true);
        } else if (customerType == "DNA" && dnaListcustId !== null) {
            customerMasterFun();
            DNAcustomerList(dnaListcustId, resType);
            getSegmentForBill();
            setPhototabdisle(true);
        } else if (customerType == "Gstvcust" && getGstcustId !== null) {
            customerMasterFun();
            setSegmtPopup(true);
            setPhototabdisle(false);
            GSTcustomerList(getGstcustId);
            viewCustomerDetailsforGST();
            if (ismobcustid == "Y") {
                setMobverifiedtag(true);
            } else {
                setMobverifiedtag(false);
            }
            //   console.log(JSON.parse(getrowdatagst), "getrowdatagst");
        }
    }, [customerType, partyCodeparam, custIdparam, essrrlicustId]);

    const dateConversion = (str) => {
    //eslint-disable-next-line
    const [day, month, year] = str?.toString().split("/");
        return `${month}/${day}/${year}`;
    };

    const getSegmentForBill = async () => {
        const segmentStream = `CustomerMast/GetStream?CICode=${auth.CICode}&UserId=${auth.UserId}`;
        const segmentStreamRes = await Axios.get(segmentStream);

        // const newSegmentStreamres = segmentStreamRes?.data?.filter((a) => {
        //   return a.STREAM_CHANNEL_DESC == "B2C";
        // });
        setSegmentStreamList(segmentStreamRes.data);
    };
    const handlesetPhoto = async () => {
        const getCustPhotourl = `${getCustomerphoto_URL}CompId=${
            auth.CompId
        }&CustId=${encodeURIComponent(custIdparam)}&fileType=Customer_Identity`;
        const getStorePhotourl = `${getCustomerphoto_URL}CompId=${
            auth.CompId
        }&CustId=${encodeURIComponent(custIdparam)}&fileType=Customer_Store`;
        const cust = await Axios.get(getCustPhotourl);
        const store = await Axios.get(getStorePhotourl);

        setGetcustImage(cust?.data ?? "");
        setGetstoreImage(store?.data ?? "");
    };

    const viewCustomerDetails = async (custIdparam, partyCodeparam) => {
        setEditCustMastLoader(true);
        handlesetPhoto();
        setPhototabdisle(false);
        setCustId(custIdparam);
        const getCustomerDetailsById_api = `${getCustomerDetailsById_URL}CICode=${
            auth.CICode
        }&UserId=${auth.UserId}&CompId=${auth.CompId}&PartyId=${encodeURIComponent(
            partyCodeparam,
        )}&CustId=${encodeURIComponent(custIdparam)}`;

        const custInfo_api = `${getCustomerInfoByCustId_URL}CICode=${
            auth.CICode
        }&CustId=${encodeURIComponent(custIdparam)}&CompId=${auth.CompId}`;
        setNewCustomerSave(false);
        setManualSegmentEnterBtn(false);
        // debugger;
        if (auth.DistTag === "I") {
            try {
                const res = await Axios.get(getCustomerDetailsById_api);
                const custInfoRes = await Axios.get(custInfo_api);
                setSegmentForEdit(custInfoRes?.data);
                const cre_date = dateConversion(res?.data?.CreationDate);
                setCreationdate(cre_date);
                const exp_date = res?.data?.ExpiryDate
                    ? dateConversion(res?.data?.ExpiryDate)
                    : "";
                setExpiryDate(exp_date);
                setEditCustMastLoader(false);
                setCustomerDetailsById(res?.data);
                if (res?.data?.GSTN_VERIFIED == "Y") {
                    setGstverifiedtag(true);
                } else {
                    setGstverifiedtag(false);
                }
                let checkKYCresponse = "";
                if (res?.data?.SegId) {
                    let checkKYCresponse_URL = await Axios.get(
                        `${hdddiststs_URL}SegId=${res.data.segId}`,
                    );
                    checkKYCresponse = checkKYCresponse_URL.data;
                }
                let diststsresponse = await Axios.get(
                    `${hdddiststs_URL}CompId=${auth.CompId}`,
                );
                let disstatusresponse = diststsresponse.data;

                if (res?.data?.KYC === "") {
                    setBasicmobrequedfield(true);
                    setBasicadd2requedfield(true);
                    setShipadd2requedfield(true);
                    setShipmobnorequedfield(true);
                    setPhototabdisle(true);
                    if (checkKYCresponse == "N") {
                        setNormalPhotoViewCS(true);
                    }
                    if (diststsresponse == "Y") {
                        setBsicmiddnamerequedfield(true);
                        setGstrequedfield(true);
                        setBasicadd2requedfield(true);
                        setBasicmobrequedfield(true);
                        setShipadd2requedfield(true);
                    }
                } else if (
                    res?.data?.KYC === "N" ||
          res?.data?.KYC === "P" ||
          res?.data?.KYC === "T"
                ) {
                    setKycfieldDisabledforHDILS(true);
                    if (disstatusresponse === "Y") {
                        setKycGSTfieldDisabledforHDILS(true);
                    }
                } else if (res?.data?.KYC === "S") {
                    if (disstatusresponse === "Y") {
                        setKycGSTfieldDisabledforHDILS(true);
                        setKycfieldDisabledforHDILS(true);
                    }
                } else {
                    setPhototabdisle(true);
                }

                if (disstatusresponse == "Y") {
                    setBsicmiddnamerequedfield(true);
                    setBasicadd2requedfield(true);
                    setBasicmobrequedfield(true);
                    setShipadd2requedfield(true);
                    setShipmiddnamerequedfield(true);
                    setShipmobnorequedfield(true);
                    if (
                        res.data.SegId != "G_P06-4|G" &&
            res.data.SegId != "G_FOA-P06-4|G" &&
            res.data.SegId != "G_P05-4|G" &&
            res.data.SegId != "G_P07-4|G"
                    ) {
                        setGstrequedfield(true);
                    }
                } else {
                    setGstrequedfield(false);
                }

                if (disstatusresponse == "Y") {
                    if (
                        res?.data?.KYC == "A" ||
            res?.data?.KYC == "R" ||
            res?.data?.KYC == "N"
                    ) {
                        setPhotoUploadndviewCS(true);
                    } else if (res?.data?.KYC == "S") {
                        setNormalPhotoViewCS(true);
                    } else {
                        setPhotoUploadndviewCS(true);
                    }
                }
            } catch (error) {
                console.log(error);
                setEditCustMastLoader(false);
            }
        } else {
            try {
                const res = await Axios.get(getCustomerDetailsById_api);
                setCustomerDetailsById(res?.data);
                setRseChecked(res?.data?.UrbanTag=="Y"?true:false);
                if (res.data.KYC === "N") {
                    setKycfieldDisabled(true);
                } else {
                    setKycStatus(false);
                    setKycfieldDisabled(false);
                }
                if (res?.data?.STREAM_CHANNEL_DESC == "B2B") {
                    setIsB2bcust(true);
                    // customer B2B and Photo  not available
                    if (
                        res?.data?.STREAM_CHANNEL_DESC == "B2B" &&
            res?.data?.CustStore?.length == 0
                    ) {
                        setPhotoUploadftCS(true);
                    } else {
                        setPhotoUploadftCS(false);
                    }
                    // customer B2B and Photo available
                    if (
                        res?.data?.STREAM_CHANNEL_DESC == "B2B" &&
            res?.data?.CustStore?.length > 0
                    ) {
                        setPhotoUploadndviewCS(true);
                    } else {
                        setPhotoUploadndviewCS(false);
                    }
                } else {
                    setNormalPhotoViewCS(true);
                }

                const custInfoRes = await Axios.get(custInfo_api);
                setSegmentForEdit(custInfoRes?.data);
                const cre_date = dateConversion(res?.data?.CreationDate);
                setCreationdate(cre_date);
                if (res?.data?.GSTN_VERIFIED == "Y") {
                    setGstverifiedtag(true);
                } else {
                    setGstverifiedtag(false);
                }
                if (res?.data?.MobileStatus == "Not Verified") {
                    setMobverifiedtag(false);
                } else {
                    setMobverifiedtag(true);
                }
                // console.log("cre000", cre_date);
                const exp_date = res?.data?.ExpiryDate
                    ? dateConversion(res?.data?.ExpiryDate)
                    : "";
                setExpiryDate(exp_date);
                setEditCustMastLoader(false);
            } catch (error) {
                console.log(error);
                setEditCustMastLoader(false);
            }
        }
    };

    const viewCustomerDetailsforGST = async () => {
        const commaSeparatedValues = Object.values(JSON.parse(getrowdatagst)).join(
            ",",
        );
        // console.log("commaSeparatedValues",commaSeparatedValues);
        let splitonbasis = commaSeparatedValues.split(",");
        // console.log(splitonbasis);
        let newcommaseparated = "";
        if (ismobcustid == "N") {
            newcommaseparated = `${splitonbasis[1]},${splitonbasis[0]},${splitonbasis[5]},${splitonbasis[4]}`;
        } else {
            newcommaseparated = `${splitonbasis[1]},${splitonbasis[2]},${splitonbasis[4]},${splitonbasis[7]},${splitonbasis[5]}`;
        }
        // console.log("newcommaseparated",newcommaseparated);
        setGstcustdetailsseparated(newcommaseparated);
        let url =
      ismobcustid == "Y"
          ? `${getCustomerDetailsById_URL}CICode=${auth.CICode}&UserId=${
              auth.UserId
          }&CompId=${auth.CompId}&PartyId=${encodeURIComponent(
              getGstcustcode,
          )}&CustId=${encodeURIComponent(
              getGstcustId,
          )}&MobileExistCustDetail=${commaSeparatedValues}`
          : `${getCustomerDetailsById_URL}CICode=${auth.CICode}&UserId=${
              auth.UserId
          }&CompId=${auth.CompId}&PartyId=${encodeURIComponent(
              getGstcustcode,
          )}&CustId=${encodeURIComponent(
              getGstcustId,
          )}&GSTExistCustDetail=${commaSeparatedValues}`;
        const getCustomerDetailsById_api = url;
        const custInfo_api = `${getCustomerInfoByCustId_URL}CICode=${auth.CICode}&CustId=${getGstcustId}&CompId=${auth.CompId}`;
        setNewCustomerSave(false);
        try {
            const res = await Axios.get(getCustomerDetailsById_api);
            setCustomerDetailsByIdGST(res?.data);
            // setCreationdate(dateConversion(res?.data.CreationDate));
            const exp_date =
        res?.data?.ExpiryDate !== ""
            ? dateConversion(res?.data?.ExpiryDate)
            : "";
            setExpiryDate(exp_date);
            if (res?.data.GSTN_VERIFIED == "V") {
                setGstverifiedtag(true);
            } else {
                setGstverifiedtag(false);
            }
            if (res.data.KYC === "N") {
                setKycfieldDisabled(true);
            } else {
                setKycStatus(false);
                setKycfieldDisabled(false);
            }
            if (res?.data?.STREAM_CHANNEL_DESC == "B2B") {
                setIsB2bcust(true);
                // customer B2B and Photo  not available
                if (
                    res?.data?.STREAM_CHANNEL_DESC == "B2B" &&
          res?.data?.CustStore?.length == 0
                ) {
                    setPhotoUploadftCS(true);
                } else {
                    setPhotoUploadftCS(false);
                }
                // customer B2B and Photo available
                if (
                    res?.data?.STREAM_CHANNEL_DESC == "B2B" &&
          res?.data?.CustStore?.length > 0
                ) {
                    setPhotoUploadndviewCS(true);
                } else {
                    setPhotoUploadndviewCS(false);
                }
            } else {
                setNormalPhotoViewCS(true);
            }

            const custInfoRes = await Axios.get(custInfo_api);
            setSegmentForEdit(custInfoRes?.data);
            const cre_date = dateConversion(res?.data?.CreationDate);
            setCreationdate(cre_date);
            // console.log("cre000", cre_date);
            // const exp_date = res?.data?.ExpiryDate
            //   ? dateConversion(res?.data?.ExpiryDate)
            //   : "";
            // setExpiryDate(exp_date);
            setEditCustMastLoader(false);
        } catch (error) {
            console.log(error);
            setEditCustMastLoader(false);
        }
    };
    useEffect(() => {
        const checkTCSappdropdata = async () => {
            // console.log(customerDetailsById.TaxFormId, "customerDetailsById");
            try {
                setEditCustMastLoader(true);
                const cnFocurl = "CustomerMast/TCSTaxPercentage?";
                const cnFocCustData = `${cnFocurl}`;
                let dataresponse = await Axios.get(cnFocCustData);
                setTcsDropDownlist(dataresponse.data);
                let defaultValue;
                if (
                    customerDetailsById?.TaxFormId == "INTRGYP|CIL" ||
          customerDetailsById?.TaxFormId == "INTEGYP|CIL" ||
          customerDetailsById?.TaxFormId == "EKLINTRGYP|CIL" ||
          customerDetailsById?.TaxFormId == "EKLINTRG01|CIL"
                ) {
                    defaultValue = dataresponse?.data.find(
                        (item) => item.TAX_PERCENTAGE === 0.1,
                    );
                } else if (
                    customerDetailsById.TaxFormId == "INTRGNP|CIL" ||
          customerDetailsById.TaxFormId == "INTEGNP|CIL" ||
          customerDetailsById.TaxFormId == "EKLINTRGNP|CIL" ||
          customerDetailsById.TaxFormId == "EKLINTRGNP1|CIL"
                ) {
                    defaultValue = dataresponse.data.find(
                        (item) => item?.TAX_PERCENTAGE === 1,
                    );
                } else if (
                    customerDetailsById?.TaxFormId == "INTRG05|CIL" ||
          customerDetailsById?.TaxFormId == "INTEG05|CIL" ||
          customerDetailsById?.TaxFormId == "EKLINTRG05|CIL" ||
          customerDetailsById?.TaxFormId == "EKLINTRG05A|CIL"
                ) {
                    defaultValue = dataresponse.data?.find(
                        (item) => item?.TAX_PERCENTAGE === 5,
                    );
                } else {
                    defaultValue = dataresponse.data?.find(
                        (item) => item?.TAX_PERCENTAGE === 0.1,
                    );
                }
                // console.log(defaultValue, "defaultValue");
                setSelectedTCS(defaultValue);
            } catch (error) {
                console.log(error);
            } finally {
                setEditCustMastLoader(false);
            }
        };
        checkTCSappdropdata();
    }, [customerDetailsById]);

    const tcsappchk = async (custID) => {
        try {
            setEditCustMastLoader(true);
            const cnFocurl = "CustomerMast/GetTCSCust?";
            const cnFocCustData = `${cnFocurl}CICode=${auth.CICode}&CompId=${
                auth.CICode
            }&CustId=${encodeURIComponent(custID)}`;
            let dataresponse = await Axios.get(cnFocCustData);
            // console.log("dataresponse", dataresponse);
            if (dataresponse.data == "Y") {
                setShowTCSdropdown(true);
            } else {
                setShowTCSdropdown(false);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setEditCustMastLoader(false);
        }
    };

    const townFilter = (e) => {
        setTimeout(() => {
            let _filteredTown;
            if (!e.query.trim().length) {
                _filteredTown = [...townList];
            } else {
                _filteredTown = townList.filter((town) => {
                    return (
                        town.PIN_CODE.toLowerCase().startsWith(e.query.toLowerCase()) ||
            town.NAME.toLowerCase().startsWith(e.query.toLowerCase())
                    );
                });
            }
            setTownSuggestion(_filteredTown);
        }, 250);
    };

    const shiptownFilter = (e) => {
        setTimeout(() => {
            let _filteredTown;
            if (!e.query.trim().length) {
                _filteredTown = [...shipTownList];
            } else {
                _filteredTown = shipTownList.filter((town) => {
                    return (
                        town.PIN_CODE.toLowerCase().startsWith(e.query.toLowerCase()) ||
            town.TOWN.toLowerCase().startsWith(e.query.toLowerCase())
                    );
                });
            }
            setShipTownSuggestion(_filteredTown);
        }, 250);
    };

    console.log(pandataverify);
    // const checckPhoneValidation = async (phnNumber) => {
    //     const phnchkURL = "CustomerMast/ChkMobExist?";
    //     const phNumbercall = `${phnchkURL}MobNo=${phnNumber.toString()}`;
    //     try {
    //         const phNumberRes = await Axios.get(phNumbercall);
    //         let phnChkResponse = phNumberRes.data;
    //         return phnChkResponse;
    //     } catch (e) {
    //         return null;
    //     }
    // };

    // let extractfile = (url)=>{
    //     const filename = url.toString().split("/").pop().split("?")[0];
    //     return filename;
    // };

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: (data) => {
            // debugger;
            setDisabledbtn(true); // disabled
            setCustomerDetailsData(data);
            // const validatePhoneNumber = async () => {
            //     try {
            //         setCustomerSaveUpdateLoader(true);
            //         let phnValidation = await checckPhoneValidation(data.cmobileno);
            //         if (phnValidation === "N") {
            //             customerMasterSave(data);
            //         } else {
            //             setPhoneValidationPopUp(true);
            //         }
            //     } catch (error) {
            //         console.error("Error in validatePhoneNumber:", error);
            //     } finally {
            //         setCustomerSaveUpdateLoader(false);
            //     }
            // };

            //     if (customerType == "normal") {
            //         if (
            //             !newCustomerSave &&
            //   customerDetailsById?.Mobile?.trim() === data.cmobileno.trim()
            //         ) {

            //         } else {
            //             validatePhoneNumber();
            //         }
            //     }
            customerMasterSave(data);
        },
        validate: (data) => {
            const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;

            //phone number regx (9089786745)
            const mobilenoRegex = new RegExp(/^[6-9]\d{9}$/);
            //space but no special character and number (Abhirup Basak)
            const nameRegex = new RegExp(/^[A-Za-z\s]+$/);
            //number regx only character and number.....no spl character (ANHJI0998N)
            // const noregx = /^[a-zA-Z0-9]+$/;
            //GST no regex
            const gstregex = new RegExp(
                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9A-Z]{1}$/,
            );
            //PAN No regex
            const panRegex = new RegExp(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/);
            //only number accept (12,909,6780)
            const numberregx = new RegExp(/^\d+$/);
            //lan line number regx
            // 022-23456789
            // +91 022 23456789
            // 022 23456789
            // (022) 23456789
            // +91 (022) 23456789
            //eslint-disable-next-line
      let phnnorgx = /^(\+91[\s\-]?)?(\(?\d{2,4}\)?[\s\-]?)\d{6,8}$/;
            // decimal regex
            //eslint-disable-next-line
      const decRegex = /^\d+(\.\d+)?$/;
            //prefix where - / @ allowed
            const prefixvalid = new RegExp(/^[a-zA-Z0-9\-_@]+$/);
            //allow only Spec char allowed [.],[,],[/],[-]
            //eslint-disable-next-line
      const Addressrgx = new RegExp(/^[A-Za-z0-9\s.,/\\\-(){}\[\]&]*$/);
            let errors = {};

            //name
            if (!data.name || (data?.name?.trim() === "" && formik.initialTouched)) {
                errors.name = "Please provide a valid Customer Name";
                //setErrorLable(true);
                setNameStatus(true);
            } else if (data.name.trim().length > 50) {
                errors.name =
          "Please enter a Name with a length of less than 50 characters";
                //setErrorLable(true);
                setNameStatus(true);
            } else {
                setNameStatus(false);
            }

            //segment
            if (!data.segment || data?.segment?.trim() === "") {
                errors.segment = "Please select Segment";
                //setErrorLable(true);
                setsegStatus(true);
            } else {
                setsegStatus(false);
            }

            //TIN NO
            //   if (data.tin_no) {
            //     if (!noregx.test(data.tin_no)) {
            //       errors.tin_no = "Please enter a valid TIN. ";
            //       //setErrorLable(true);
            //       setTinStatus(true);
            //     } else if (data.tin_no.length > 11) {
            //       errors.tin_no = "Invalid TIN Number length should be less than 11";
            //       setTinStatus(true);
            //       //setErrorLable(true);
            //     } else {
            //       setTinStatus(false);
            //     }
            //   } else {
            //     setTinStatus(false);
            //   }

            //PAN NO
            if (data.pan_no) {
                if (!panRegex.test(data.pan_no)) {
                    errors.pan_no = "Invalid PAN Number";
                    //setErrorLable(true);
                    setPannoStatus(true);
                } else if (data.pan_no.length > 10) {
                    errors.pan_no = "Invalid PAN Number length should be less than 10";
                    setPannoStatus(true);
                } else {
                    setPannoStatus(false);
                }
            } else {
                setPannoStatus(false);
            }

            if (gstrequedfield) {
                if (!data.gst_no || data?.gst_no?.trim() === "") {
                    errors.gst_no = "Please enter GST Number";
                    //setErrorLable(true);
                    setGstnoStatus(true);
                } else if (data.gst_no) {
                    if (!gstregex.test(data.gst_no)) {
                        errors.gst_no = "Invalid GST Number";
                        //setErrorLable(true);
                        setGstnoStatus(true);
                    } else if (data.gst_no.length > 15) {
                        errors.gst_no = "Invalid GST Number length should be less than 15";
                        setGstnoStatus(true);
                    } else {
                        setGstnoStatus(false);
                    }
                } else {
                    setGstnoStatus(false);
                }
            }

            //   if(hdILScustomer||forkycrequedfield){
            //     if(data.kyc_check==false){
            //         errors.kyc_check = "Please check status";
            //         setStatuserror(true);
            //         //setErrorLable(true);
            //     }else{
            //         setStatuserror(false);
            //         //setErrorLable(false);
            //     }
            //   }

            //GST No
            if (data.gst_no) {
                if (!gstregex.test(data.gst_no)) {
                    errors.gst_no = "Invalid GST Number";
                    //setErrorLable(true);
                    setGstnoStatus(true);
                } else if (data.gst_no.length > 15) {
                    errors.gst_no = "Invalid GST Number length should be less than 15";
                    setGstnoStatus(true);
                } else {
                    setGstnoStatus(false);
                }
            } else {
                setGstnoStatus(false);
            }

            //prefix
            if (data.prefix) {
                if (!prefixvalid.test(data.prefix)) {
                    errors.prefix = "Invalid Prefix";
                    //setErrorLable(true);
                    setPrefixStatus(true);
                } else if (data.prefix.length > 10) {
                    errors.prefix = "Invalid Prefix length should be less than 10";
                    setPrefixStatus(true);
                } else {
                    setPrefixStatus(false);
                }
            } else {
                setPrefixStatus(false);
            }

            //first name
            if (!data.cfname || data?.cfname?.trim() === "") {
                errors.cfname = "Please enter First Name";
                //setErrorLable(true);
                setFnameStatus(true);
            } else if (data.cfname) {
                if (data.cfname.trim().length > 30) {
                    errors.cfname = "Name length should be under 30 limitation";
                    //setErrorLable(true);
                    setFnameStatus(true);
                } else {
                    if (!nameRegex.test(data.cfname)) {
                        errors.cfname =
              "Invalid name. Numbers and special characters are not allowed";
                        //setErrorLable(true);
                        setFnameStatus(true);
                    } else {
                        setFnameStatus(false);
                    }
                }
            }

            //middle name
            if (bsicmiddnamerequedfield) {
                if (!data.cmname || data?.cmname?.trim() === "") {
                    errors.cmname = "Please enter middle Name";
                    //setErrorLable(true);
                    setMidnameStatus(true);
                } else if (data.cmname) {
                    if (data.cmname.trim().length > 30) {
                        errors.cmname = "Middle Name length should be under 30 limitation";
                        //setErrorLable(true);
                        setMidnameStatus(true);
                    } else {
                        if (!nameRegex.test(data.cmname)) {
                            errors.cmname =
                "Invalid middle name. Numbers and special characters are not allowed";
                            //setErrorLable(true);
                            setMidnameStatus(true);
                        } else {
                            setMidnameStatus(false);
                        }
                    }
                }
            }
            if (data.cmname) {
                if (!nameRegex.test(data.cmname)) {
                    errors.cmname = "Invalid Name. Only letters are allowed.";
                    //setErrorLable(true);
                    setMidnameStatus(true);
                } else if (data.cmname.trim().length > 30) {
                    errors.cmname = "Name length should be under 30 limitation.";
                    //setErrorLable(true);
                    setMidnameStatus(true);
                } else {
                    if (!nameRegex.test(data.cmname)) {
                        errors.cmname =
              "Invalid name. Numbers and special characters are not allowed.";
                        //setErrorLable(true);
                        setMidnameStatus(true);
                    } else {
                        setMidnameStatus(false);
                    }
                }
            }
            //last name
            if (!data.clname || data?.clname?.trim() === "") {
                errors.clname = "Please enter Last Name";
                //setErrorLable(true);
                setLnameStatus(true);
            } else if (data.clname) {
                if (data.clname.trim().length > 30) {
                    errors.clname = "Last Name length should be under 30 limitation.";
                    //setErrorLable(true);
                    setLnameStatus(true);
                } else {
                    if (!nameRegex.test(data.clname)) {
                        errors.clname =
              "Invalid name. Numbers and special characters are not allowed.";
                        //setErrorLable(true);
                        setLnameStatus(true);
                    } else {
                        setLnameStatus(false);
                    }
                }
            }

            //phone number
            if (data.cphoneno) {
                if (!phnnorgx.test(data.cphoneno)) {
                    errors.cphoneno = "Please enter Valid Phone Number";
                    //setErrorLable(true);
                    setPhnoStatus(true);
                } else {
                    setPhnoStatus(false);
                }
            } else {
                setPhnoStatus(false);
            }
            //mobile no req
            if (basicmobrequedfield) {
                if (!data.cmobileno || data?.cmobileno?.trim() === "") {
                    errors.cmobileno = "Please enter Mobile Number";
                    setMobileStatus(true);
                } else {
                    if (!mobilenoRegex.test(data.cmobileno)) {
                        errors.cmobileno = "Please enter Valid Mobile Number";
                        //setErrorLable(true);
                        setMobileStatus(true);
                    } else {
                        setMobileStatus(false);
                    }
                }
            }

            //mobile no
            if (!data.cmobileno || data?.cmobileno?.trim() === "") {
                errors.cmobileno = "Please enter Mobile Number";
                setMobileStatus(true);
            } else {
                if (!mobilenoRegex.test(data.cmobileno)) {
                    errors.cmobileno = "Please enter Valid Mobile Number";
                    //setErrorLable(true);
                    setMobileStatus(true);
                } else {
                    setMobileStatus(false);
                }
            }
            //mail
            if (data.cemail) {
                if (!emailRegex.test(data.cemail)) {
                    errors.cemail = "Invalid email format";
                    //setErrorLable(true);
                    setCemailStatus(true);
                } else if (data.cemail.length > 60) {
                    errors.cemail = "Email length should be under 60 limitation.";
                    //setErrorLable(true);
                    setCemailStatus(true);
                } else {
                    setCemailStatus(false);
                }
            } else {
                setCemailStatus(false);
            }

            //address 1
            if (!data.bill_add1 || data?.bill_add1?.trim() === "") {
                errors.bill_add1 = "Please enter Address 1";
                //setErrorLable(true);
                setAddress1Status(true);
            } else if (data.bill_add1) {
                if (!Addressrgx.test(data.bill_add1)) {
                    errors.bill_add1 = "No special character is allowed";
                    //setErrorLable(true);
                    setAddress1Status(true);
                } else if (data.bill_add1.length > 70) {
                    errors.bill_add1 = "Address1 length should be under 70 limitation.";
                    //setErrorLable(true);
                    setAddress1Status(true);
                } else {
                    setAddress1Status(false);
                }
            }
            //address 2 req

            if (basicadd2requedfield) {
                if (!data.bill_add2 || data?.bill_add2?.trim() === "") {
                    errors.bill_add2 = "Please enter Address 2";
                    //setErrorLable(true);
                    setAddress2Status(true);
                } else if (data.bill_add2) {
                    if (!Addressrgx.test(data.bill_add2)) {
                        errors.bill_add2 = "No special character is allowed";
                        //setErrorLable(true);
                        setAddress2Status(true);
                    } else if (data.bill_add2.length > 70) {
                        errors.bill_add2 =
              "Address 2 length should be under 70 limitation.";
                        //setErrorLable(true);
                        setAddress2Status(true);
                    } else {
                        setAddress2Status(false);
                    }
                }
            }
            //address 2
            if (!data.bill_add2 || data?.bill_add2?.trim() === "") {
                errors.bill_add2 = "Please enter Address 2";
                //setErrorLable(true);
                setAddress2Status(true);
            } else if (data.bill_add2) {
                if (!Addressrgx.test(data.bill_add2)) {
                    errors.bill_add2 = "No special character is allowed";
                    //setErrorLable(true);
                    setAddress2Status(true);
                } else if (data.bill_add2.length > 70) {
                    errors.bill_add2 = "Address 2 length should be under 70 limitation.";
                    //setErrorLable(true);
                    setAddress2Status(true);
                } else {
                    setAddress2Status(false);
                }
            }

            //town
            if (!data.bill_town) {
                errors.bill_town = "Please select Town";
                //setErrorLable(true);
                setTownStatus(true);
            } else {
                setTownStatus(false);
            }

            //credit hold
            if (!data.credit_hold) {
                errors.credit_hold = "Please choose Credit hold";
                //setErrorLable(true);
                setCreditHoldStatus(true);
            } else {
                setCreditHoldStatus(false);
            }

            //payment term
            if (!data.payment_term) {
                errors.payment_term = "Please select Payment Term.";
                //setErrorLable(true);
                setPaymentTermStatus(true);
            } else {
                setPaymentTermStatus(false);
            }

            //tax area
            if (!data.tax_area) {
                errors.tax_area = "Please select Tax Area.";
                //setErrorLable(true);
                setTaxAreaStatus(true);
            } else {
                setTaxAreaStatus(false);
            }

            //payment mode
            if (!data.payment_mode) {
                errors.payment_mode = "Please select Payment Mode.";
                //setErrorLable(true);
                setPaymentModeStatus(true);
            } else {
                setPaymentModeStatus(false);
            }

            //credit limit
            if (data.credit_limit) {
                if (!decRegex.test(data.credit_limit)) {
                    errors.credit_limit =
            "Invalid Credit limit. Only decimal upto two digits are allowed.";
                    //setErrorLable(true);
                    setCreditlimStatus(true);
                } else if (data.credit_limit > 10000000.99) {
                    errors.credit_limit = "Invalid Credit limit.";
                    //setErrorLable(true);
                    setCreditlimStatus(true);
                } else {
                    setCreditlimStatus(false);
                }
            } else {
                setCreditlimStatus(false);
            }

            //trade discount
            if (!data.trade_discount) {
                errors.trade_discount = "Please enter Trade Discount";
                //setErrorLable(true);
                setTradeDiscStatus(true);
            } else if (data.trade_discount > 99) {
                errors.trade_discount = "Trade Discount length should be maximum 99%.";
                //setErrorLable(true);
                setTradeDiscStatus(true);
            } else {
                if (!decRegex.test(data.trade_discount)) {
                    errors.trade_discount = "Invalid Trade Discount.";
                    //setErrorLable(true);
                    setTradeDiscStatus(true);
                } else {
                    setTradeDiscStatus(false);
                }
            }

            // min order
            if (data.min_order) {
                if (!decRegex.test(data.min_order)) {
                    errors.min_order = "Invalid order Number";
                    //setErrorLable(true);
                    setMinorderStatus(true);
                } else if (data.min_order > 1000) {
                    errors.min_order = "Invalid order limit";
                    //setErrorLable(true);
                    setMinorderStatus(true);
                } else {
                    setMinorderStatus(false);
                }
            } else {
                setMinorderStatus(false);
            }
            // //max order
            if (data.max_order) {
                if (!decRegex.test(data.max_order)) {
                    errors.max_order = "Invalid order Number";
                    //setErrorLable(true);
                    setMaxorderStatus(true);
                } else if (data.max_order > 10000) {
                    errors.max_order = "Invalid order Limit";
                    //setErrorLable(true);
                    setMaxorderStatus(true);
                } else {
                    setMaxorderStatus(false);
                }
            } else {
                setMaxorderStatus(false);
            }
            //transport charge
            if (data.transport_charges) {
                if (!decRegex.test(data.transport_charges)) {
                    errors.transport_charges = "Invalid input";
                    //setErrorLable(true);
                    setTranschrgStatus(true);
                } else if (data.transport_charges.length > 8) {
                    errors.transport_charges = "Invalid transport_charges";
                    //setErrorLable(true);
                    setTranschrgStatus(true);
                } else {
                    setTranschrgStatus(false);
                }
            } else {
                setTranschrgStatus(false);
            }
            //priority
            if (data.priority) {
                if (!numberregx.test(data.priority)) {
                    errors.priority = "Invalid input";
                    //setErrorLable(true);
                    setPriortyStatus(true);
                } else if (data.priority.length > 8) {
                    errors.priority = "Invalid priority";
                    //setErrorLable(true);
                    setPriortyStatus(true);
                } else {
                    setPriortyStatus(false);
                }
            } else {
                setPriortyStatus(false);
            }

            //delivery instruction
            if (data.delivery_inst) {
                if (!nameRegex.test(data.delivery_inst)) {
                    errors.delivery_inst = "Invalid input";
                    //setErrorLable(true);
                    setDelvinsStatus(true);
                } else if (data.delivery_inst.length > 60) {
                    errors.delivery_inst = "Invalid instruction, should be less than 60";
                    //setErrorLable(true);
                    setDelvinsStatus(true);
                } else {
                    setDelvinsStatus(false);
                }
            } else {
                setDelvinsStatus(false);
            }
            // billing instruction
            if (data.billing_inst) {
                if (!nameRegex.test(data.billing_inst)) {
                    errors.billing_inst = "Invalid input";
                    //setErrorLable(true);
                    setBillinsStatus(true);
                } else if (data.billing_inst.length > 60) {
                    errors.billing_inst = "Invalid instruction. should be less than 60";
                    //setErrorLable(true);
                    setBillinsStatus(true);
                } else {
                    setBillinsStatus(false);
                }
            } else {
                setBillinsStatus(false);
            }

            //delivery
            if (!data.p_day_of_delivery) {
                errors.p_day_of_delivery = "Please select Prefered Delivery Day";
                //setErrorLable(true);
                setPreferedDayStatus(true);
            } else {
                setPreferedDayStatus(false);
            }

            //employee select
            if (!data.employeeSelect) {
                errors.employeeSelect = "Please select Executive Name";
                //setErrorLable(true);
            }
            //beat frequency
            if (!data.beat_frequency) {
                errors.beat_frequency = "Please select Visit Frequency.";
                //setErrorLable(true);
            }
            //day beat
            if (!data.day_of_beat1) {
                errors.day_of_beat1 = "Please select Customer Visit Day.";
                //setErrorLable(true);
            }

            //address 1 (shipping)

            if (!data.sadd1 || data?.sadd1?.trim() === "") {
                errors.sadd1 = "Please enter Address 1";
                //setErrorLable(true);
                setAddress1Status1(true);
            } else if (data.sadd1) {
                if (!Addressrgx.test(data.sadd1)) {
                    errors.sadd1 = "No special character is allowed";
                    //setErrorLable(true);
                    setAddress1Status1(true);
                } else if (data.sadd1.length > 70) {
                    errors.sadd1 = "Address 1 length should be 70.";
                    //setErrorLable(true);
                    setAddress1Status1(true);
                } else {
                    setAddress1Status1(false);
                }
            }
            //address2(shipping)

            if (shipadd2requedfield) {
                if (!data.sadd2 || data?.sadd2?.trim() === "") {
                    errors.sadd2 = "Please enter Address 2";
                    //setErrorLable(true);
                    setShipaddStatus(true);
                } else if (data.sadd2) {
                    if (!Addressrgx.test(data.sadd2)) {
                        errors.sadd2 = "No special character is allowed";
                        //setErrorLable(true);
                        setShipaddStatus(true);
                    } else if (data.sadd2.length > 70) {
                        errors.sadd2 = "Address 1 length should be 70.";
                        //setErrorLable(true);
                        setShipaddStatus(true);
                    } else {
                        setShipaddStatus(false);
                    }
                }
            }

            if (data.sadd2 || data?.sadd2?.trim() === "") {
                if (data.sadd2.length > 70) {
                    errors.sadd2 = "Address 2 length should be  70.";
                    //setErrorLable(true);
                    setShipaddStatus(true);
                } else if (!Addressrgx.test(data.sadd2)) {
                    errors.sadd2 = "No special character is allowed";
                    //setErrorLable(true);
                    setShipaddStatus(true);
                } else {
                    setShipaddStatus(false);
                }
            } else {
                setShipaddStatus(false);
            }

            //town (shipping)
            if (!data.ship_town) {
                errors.ship_town = "Please select Town";
                //setErrorLable(true);
                setTownStatus1(true);
            } else {
                setTownStatus1(false);
            }

            //van route
            // if (!data.van_route) {
            //     errors.van_route = "Please select Van Route";
            //     //setErrorLable(true);
            //     setVanRouteStatus(true);
            // } else {
            //     setVanRouteStatus(false);
            // }

            //GST NO SHIP
            if (data.ship_gst_no) {
                if (!gstregex.test(data.ship_gst_no)) {
                    errors.ship_gst_no = "Invalid GST No.";
                    //setErrorLable(true);
                    setShipgstStatus(true);
                } else if (data.ship_gst_no.length > 15) {
                    errors.ship_gst_no =
            "Invalid GST Number length should be less than 15";
                    setShipgstStatus(true);
                } else {
                    setShipgstStatus(false);
                }
            } else {
                setShipgstStatus(false);
            }

            //title
            if (data.ship_title) {
                if (!nameRegex.test(data.ship_title)) {
                    errors.ship_title = "Invalid input";
                    //setErrorLable(true);
                    setStitleStatus(true);
                } else if (data.ship_title.length > 10) {
                    errors.ship_title = "Prefix length should be under 10 limitation.";
                    //setErrorLable(true);
                    setStitleStatus(true);
                } else {
                    setStitleStatus(false);
                }
            } else {
                setStitleStatus(false);
            }

            //first name(shipping)
            if (!data.fname || data?.fname?.trim() === "") {
                errors.fname = "Please enter First Name";
                //setErrorLable(true);
                setFnameStatus1(true);
            } else if (data.fname) {
                if (data.fname.trim().length > 30) {
                    errors.fname = "Name length should be under 15.";
                    //setErrorLable(true);
                    setFnameStatus1(true);
                } else {
                    if (!nameRegex.test(data.fname)) {
                        errors.fname =
              "Invalid name. Numbers and special characters are not allowed.";
                        //setErrorLable(true);
                        setFnameStatus1(true);
                    } else {
                        setFnameStatus1(false);
                    }
                }
            }
            //middle name (shipping)
            if (shipmiddnamerequedfield) {
                if (!data.mname || data?.mname?.trim() === "") {
                    errors.mname = "Please enter middle Name";
                    //setErrorLable(true);
                    setSmidnameStatus(true);
                } else if (data.mname) {
                    if (data.mname.trim().length > 30) {
                        errors.mname = "Middle name length should be under 15.";
                        //setErrorLable(true);
                        setSmidnameStatus(true);
                    } else {
                        if (!nameRegex.test(data.mname)) {
                            errors.mname =
                "Invalid middle name. Numbers and special characters are not allowed.";
                            //setErrorLable(true);
                            setSmidnameStatus(true);
                        } else {
                            setSmidnameStatus(false);
                        }
                    }
                }
            }

            if (data.mname) {
                if (!nameRegex.test(data.mname)) {
                    errors.mname = "Invalid Name. Only letters are allowed.";
                    //setErrorLable(true);
                    setSmidnameStatus(true);
                } else if (data.mname.trim().length > 30) {
                    errors.cmname = "Name length should be under 30 limitation.";
                    //setErrorLable(true);
                    setSmidnameStatus(true);
                } else {
                    if (!nameRegex.test(data.mname)) {
                        errors.mname =
              "Invalid name. Numbers and special characters are not allowed.";
                        //setErrorLable(true);
                        setSmidnameStatus(true);
                    } else {
                        setSmidnameStatus(false);
                    }
                }
            }

            //last name (shipping)
            if (!data.lname || data?.lname?.trim() === "") {
                errors.lname = "Please enter Last Name";
                //setErrorLable(true);
                setLnameStatus1(true);
            } else if (data.lname) {
                if (data.lname.trim().length > 30) {
                    errors.lname = "Last name length should be under 30.";
                    //setErrorLable(true);
                    setLnameStatus1(true);
                } else {
                    if (!nameRegex.test(data.lname)) {
                        errors.lname =
              "Invalid name. Numbers and special characters are not allowed.";
                        //setErrorLable(true);
                        setLnameStatus1(true);
                    } else {
                        setLnameStatus1(false);
                    }
                }
            }
            //phone number (shipping)
            if (data.phno) {
                if (!phnnorgx.test(data.phno)) {
                    errors.phno = "Invalid Phone Number.";
                    //setErrorLable(true);
                    setSphnumStatus(true);
                } else {
                    setSphnumStatus(false);
                }
            } else {
                setSphnumStatus(false);
            }

            if (shipmobnorequedfield) {
                if (!data.mob) {
                    errors.mob = "Please enter Mobile Number";
                    setMobileStatus1(true);
                } else {
                    if (!mobilenoRegex.test(data.mob)) {
                        errors.mob = "Invalid mobile no.";
                        //setErrorLable(true);
                        setMobileStatus1(true);
                    } else {
                        setMobileStatus1(false);
                    }
                }
            }

            //mobile no (shipping)
            if (!data.mob) {
                errors.mob = "Please enter Mobile Number";
                setMobileStatus1(true);
            } else {
                if (!mobilenoRegex.test(data.mob)) {
                    errors.mob = "Invalid mobile no.";
                    //setErrorLable(true);
                    setMobileStatus1(true);
                } else {
                    setMobileStatus1(false);
                }
            }

            // //ship mail
            // if (data.ship_co_email) {
            //     if (data.ship_co_email.length > 60) {
            //         errors.ship_co_email = "Email length should be under 60 limitation.";
            //         //setErrorLable(true);
            //         setShipemailStatus(true);
            //     } else {
            //         setShipemailStatus(false);
            //     }
            // }

            //ship email
            // if (data.ship_co_email) {
            //   if (!emailRegex.test(data.ship_co_email)) {
            //     errors.ship_co_email = "Invalid input email type";
            //     //setErrorLable(true);
            //   }
            // }

            if (data.ship_co_email) {
                if (!emailRegex.test(data.ship_co_email)) {
                    errors.ship_co_email = "Invalid email format";
                    //setErrorLable(true);
                    setShipemailStatus(true);
                } else if (data.ship_co_email.length > 60) {
                    errors.ship_co_email = "Email length should be under 60 limitation.";
                    //setErrorLable(true);
                    setShipemailStatus(true);
                } else {
                    setShipemailStatus(false);
                }
            } else {
                setShipemailStatus(false);
            }

            if (data.cust_url != null) {
                if (data?.cust_url?.size > 500 * 1024) {
                    errors.cust_url = "File size is too large. Maximum size is 500 KB.";
                } else if (
                    !["image/jpeg", "image/jpg"].includes(data?.cust_url?.type)
                ) {
                    errors.cust_url = "Unsupported file format";
                }
            }

            if (data.cust_store != null) {
                if (data?.cust_store?.size > 500 * 1024) {
                    errors.cust_store = "File size is too large. Maximum size is 500 KB.";
                } else if (
                    !["image/jpeg", "image/jpg"].includes(data?.cust_store?.type)
                ) {
                    errors.cust_store = "Unsupported file format";
                }
            }
            return errors;
        },
    });

    // use for Customer KYC Status
    // useEffect(() => {
    //   if (!newCustomerSave) {
    //     if (customerDetailsById?.KYC == "S" || customerDetailsById?.KYC == "R") {
    //       toast.error(
    //         `KYC Status of the selected customer is ${
    //           customerDetailsById.KYC == "S"
    //             ? "Billing Stopped"
    //             : customerDetailsById.KYC == "R"
    //             ? "Rejected"
    //             : ""
    //         }, kindly get the customer KYC Approved to continue`,
    //         {
    //           position: toast.POSITION.TOP_CENTER,
    //           pauseOnFocusLoss: false,
    //           closeButton: false,
    //           autoClose: 4000,
    //         }
    //       );
    //     }
    //   }
    // }, [customerDetailsById]);

    //for edit setting formik values Normal customer
    // console.log(formik);
    useEffect(() => {
    // debugger;
        if (customerType == "normal") {
            formik.setValues({
                comments: "",
                code: customerDetailsById?.PartyId,
                name: customerDetailsById?.Name,
                unique_code: customerDetailsById?.UniqueCode,
                segment: customerDetailsById?.Segment,
                creation_date: new Date(creationDate),
                expiry_date:
          customerDetailsById?.ExpiryDate == "" ? "" : new Date(expiryDate),
                tax_form: taxForm.filter((val) => {
                    return val.NAME == customerDetailsById?.TaxForm;
                })[0],
                payment_term: paymentTerm.find(
                    (val) => val.NAME === customerDetailsById?.PayTerm,
                ),
                tax_area: taxArea?.find(
                    (val) => val.NAME === customerDetailsById?.TaxArea,
                ),
                payment_mode: modeOfPayment.find(
                    (val) => val.NAME === customerDetailsById?.ModeOfPayment,
                ),
                p_day_of_delivery: preferedDay.find(
                    (val) => val.id === customerDetailsById.PrefferedDay,
                ),
                employeeSelect: customerDetailsById.Employee
                    ? employeeList.find(
                        (val) => val.NAME === customerDetailsById.Employee,
                    )
                    : null,
                beat_frequency: beatFrequency.find(
                    (val) => val.NAME === customerDetailsById.Frequency,
                ),
                day_of_beat1: customerDetailsById.DayOfWeekCode
                    ? dayOfWeek.find(
                        (val) =>
                            val?.CODE.toString() === customerDetailsById?.DayOfWeekCode,
                    )
                    : null,

                bill_town: townList.find(
                    (val) =>
                        val.NAME === customerDetailsById.Town &&
            val.GEOG_ID === customerDetailsById.BillGeogId,
                ),
                ship_town: shipTownList.find(
                    (val) => val.TOWN === customerDetailsById.ShipTown,
                ),
                kyc_status: getKYCStatus(customerDetailsById.KYC),
                kyc_check: customerDetailsById.Status === "Y" ? true : false,
                latitude: customerDetailsById.Lat || latitude,
                longitude: customerDetailsById.Long || longitude,
                pan_no: customerDetailsById.PAN_NO,
                caadhar: customerDetailsById.AADHARNO,
                gst_no: customerDetailsById.GSTNo,
                prefix: customerDetailsById.Prefix,
                cfname: customerDetailsById.Firstname,
                cmname: customerDetailsById.MiddleName,
                clname: customerDetailsById.Lastname,
                cphoneno: customerDetailsById.PhoneNo,
                cmobileno: customerDetailsById.Mobile,
                cemail: customerDetailsById.Email,
                bill_add1: customerDetailsById.Add1,
                bill_add2: customerDetailsById.Add2,
                bill_state: customerDetailsById.State,
                bill_district: customerDetailsById.District,
                bill_zipcode: customerDetailsById.Pincode,
                ship_to_name: customerDetailsById.ShipToName,
                sadd1: customerDetailsById.ShipAdd1,
                sadd2: customerDetailsById.ShipAdd2,
                ship_state: customerDetailsById.ShipState,
                ship_district: customerDetailsById.ShipDistrict,
                ship_zipcode: customerDetailsById.ShipPinCode,
                min_order: customerDetailsById.MinOrderVal,
                max_order: customerDetailsById.MaxOrderVal,
                transport_charges: customerDetailsById.TransportCharges,
                priority: customerDetailsById.Priority,
                delivery_inst: customerDetailsById.CustdeliveryInst,
                billing_inst: customerDetailsById.BillingIns,
                van_route: vanRoute.find(
                    (val) => val.NAME === customerDetailsById.VanRt,
                ),
                ship_title: customerDetailsById.ShipTitle,
                copy_to_ship_contact:
          customerDetailsById.ShipFirstname == customerDetailsById.Firstname &&
          customerDetailsById.ShipMiddlename ==
            customerDetailsById.MiddleName &&
          customerDetailsById.ShipLastname == customerDetailsById.Lastname &&
          customerDetailsById.ShipPhoneNo == customerDetailsById.PhoneNo &&
          customerDetailsById.ShipOtherPhoneNo == customerDetailsById.Mobile
              ? true
              : false,
                // copy_to_ship_address:
                // (customerDetailsById.BillGeogId == customerDetailsById.ShipGeogId)?true:false,
                fname: customerDetailsById.ShipFirstname,
                mname: customerDetailsById.ShipMiddlename,
                lname: customerDetailsById.ShipLastname,
                phno: customerDetailsById.ShipPhoneNo,
                mob: customerDetailsById.ShipOtherPhoneNo,
                ship_co_email: customerDetailsById.ShipEmail,
                invoice_copy: customerDetailsById.InvCopies,
                credit_limit: customerDetailsById.CreditLimit,
                trade_discount: customerDetailsById.TradeDiscount,
                credit_hold: customerDetailsById.CreditHold,
                app_per: customerDetailsById.AppPermission,
                ship_gst_no: customerDetailsById.ShipToGSTN,
                tin_no: customerDetailsById.TINNO,
                cust_viewurl: getcustImage,
                cust_viewstore: getstoreImage,
                cust_url: null,
                cust_store: null,
                // tcsapp: bydefTCSval,
            });
        }
    }, [customerDetailsById, townList]);
    useEffect(() => {
    // debugger;
        if (customerType == "Gstvcust") {
            formik.setValues({
                comments: "",
                code: customerDetailsByIdGST?.AccountId,
                name: customerDetailsByIdGST?.Name,
                unique_code: customerDetailsByIdGST?.UniqueCode,
                segment: customerDetailsByIdGST?.Segment,
                creation_date: new Date(creationDate),
                expiry_date:
          customerDetailsByIdGST?.ExpiryDate == "" ? "" : new Date(expiryDate),
                tax_form: taxForm.filter((val) => {
                    return val.NAME == customerDetailsByIdGST?.TaxForm;
                })[0],
                payment_term: paymentTerm.find(
                    (val) => val.NAME === customerDetailsByIdGST?.PayTerm,
                ),
                tax_area: taxArea?.find(
                    (val) => val.NAME === customerDetailsByIdGST?.TaxArea,
                ),
                payment_mode: modeOfPayment.find(
                    (val) => val.NAME === customerDetailsByIdGST?.ModeOfPayment,
                ),
                p_day_of_delivery: preferedDay.find(
                    (val) => val.id === customerDetailsByIdGST.PrefferedDay,
                ),
                employeeSelect: customerDetailsByIdGST.Employee
                    ? employeeList.find(
                        (val) => val.NAME === customerDetailsByIdGST.Employee,
                    )
                    : null,
                beat_frequency: beatFrequency.find(
                    (val) => val.NAME === customerDetailsByIdGST.Frequency,
                ),
                day_of_beat1: customerDetailsByIdGST.DayOfWeekCode
                    ? dayOfWeek.find(
                        (val) =>
                            val?.CODE.toString() === customerDetailsByIdGST?.DayOfWeekCode,
                    )
                    : null,

                bill_town: townList.find(
                    (val) =>
                        val.NAME === customerDetailsByIdGST.Town &&
            val.GEOG_ID === customerDetailsByIdGST.BillGeogId,
                ),
                ship_town: shipTownList.find(
                    (val) => val.TOWN === customerDetailsByIdGST.ShipTown,
                ),
                kyc_status: getKYCStatus(customerDetailsByIdGST.KYC),
                kyc_check: customerDetailsByIdGST.Status === "Y" ? true : false,
                latitude: customerDetailsByIdGST.Lat || latitude,
                longitude: customerDetailsByIdGST.Long || longitude,
                pan_no: customerDetailsByIdGST.PAN_NO,
                caadhar: customerDetailsByIdGST.AADHARNO,
                gst_no: customerDetailsByIdGST.GSTNo,
                prefix: customerDetailsByIdGST.Prefix,
                cfname: customerDetailsByIdGST.Firstname,
                cmname: customerDetailsByIdGST.MiddleName,
                clname: customerDetailsByIdGST.Lastname,
                cphoneno: customerDetailsByIdGST.PhoneNo,
                cmobileno: customerDetailsByIdGST.Mobile,
                cemail: customerDetailsByIdGST.Email,
                bill_add1: customerDetailsByIdGST.Add1,
                bill_add2: customerDetailsByIdGST.Add2,
                bill_state: customerDetailsByIdGST.State,
                bill_district: customerDetailsByIdGST.District,
                bill_zipcode: customerDetailsByIdGST.Pincode,
                ship_to_name: customerDetailsByIdGST.ShipToName,
                sadd1: customerDetailsByIdGST.ShipAdd1,
                sadd2: customerDetailsByIdGST.ShipAdd2,
                ship_state: customerDetailsByIdGST.ShipState,
                ship_district: customerDetailsByIdGST.ShipDistrict,
                ship_zipcode: customerDetailsByIdGST.ShipPinCode,
                min_order: customerDetailsByIdGST.MinOrderVal,
                max_order: customerDetailsByIdGST.MaxOrderVal,
                transport_charges: customerDetailsByIdGST.TransportCharges,
                priority: customerDetailsByIdGST.Priority,
                delivery_inst: customerDetailsByIdGST.CustdeliveryInst,
                billing_inst: customerDetailsByIdGST.BillingIns,
                van_route: vanRoute.find(
                    (val) => val.NAME === customerDetailsByIdGST.VanRt,
                ),
                ship_title: customerDetailsByIdGST.ShipTitle,
                copy_to_ship_contact:
          customerDetailsByIdGST.ShipFirstname ==
            customerDetailsByIdGST.Firstname &&
          customerDetailsByIdGST.ShipMiddlename ==
            customerDetailsByIdGST.MiddleName &&
          customerDetailsByIdGST.ShipLastname ==
            customerDetailsByIdGST.Lastname &&
          customerDetailsByIdGST.ShipPhoneNo ==
            customerDetailsByIdGST.PhoneNo &&
          customerDetailsByIdGST.ShipOtherPhoneNo ==
            customerDetailsByIdGST.Mobile
              ? true
              : false,
                // copy_to_ship_address:
                // (customerDetailsById.BillGeogId == customerDetailsById.ShipGeogId)?true:false,
                fname: customerDetailsByIdGST.ShipFirstname,
                mname: customerDetailsByIdGST.ShipMiddlename,
                lname: customerDetailsByIdGST.ShipLastname,
                phno: customerDetailsByIdGST.ShipPhoneNo,
                mob: customerDetailsByIdGST.ShipOtherPhoneNo,
                ship_co_email: customerDetailsByIdGST.ShipEmail,
                invoice_copy: customerDetailsByIdGST.InvCopies,
                credit_limit: customerDetailsByIdGST.CreditLimit,
                trade_discount: customerDetailsByIdGST.TradeDiscount,
                credit_hold: customerDetailsByIdGST.CreditHold,
                app_per: customerDetailsByIdGST.AppPermission,
                ship_gst_no: customerDetailsByIdGST.ShipToGSTN,
                tin_no: customerDetailsByIdGST.TINNO,
                cust_viewurl: getcustImage,
                cust_viewstore: getstoreImage,
                cust_url: null,
                cust_store: null,
                // tcsapp: bydefTCSval,
            });
        }
    }, [customerDetailsByIdGST, townList]);

    const EssrRLIcustomerList = async (essrRliId) => {
        const getCustomerDetailsById_api = `${getCustomerDetailsById_URL}CICode=${auth.CICode}&UserId=${auth.UserId}&CompId=${auth.CompId}&PartyId=null&CustId=null&AwaitedRILDetails=${essrRliId}`;
        try {
            const res = await Axios.get(getCustomerDetailsById_api);
            setEssrrliCustomerDetails(res.data);
            // console.log("a00", res?.data.BillGeogId);
            handleshipsalesArea(res?.data.BillGeogId);
        } catch (error) {
            console.log(error);
        }
    };

    console.log("dnaCustomerDetails", dnaCustomerDetails);

    useEffect(() => {
        if (customerType == "RLIESSR") {
            formik.setValues({
                comments: "",
                code: "",
                name: essrrliCustomerDetails.Name,
                creation_date: new Date(),
                payment_term: paymentTerm.find(
                    (val) => val.NAME === customerDetailsById.PayTerm,
                ),
                payment_mode: modeOfPayment.find(
                    (val) => val.NAME === essrrliCustomerDetails.ModeOfPayment,
                ),
                bill_town: townList.find(
                    (val) =>
                        val.NAME === essrrliCustomerDetails.Town &&
            val.GEOG_ID === essrrliCustomerDetails.BillGeogId,
                ),
                ship_town: shipTownList.find(
                    (val) => val.PIN_CODE === essrrliCustomerDetails.ShipPinCode,
                ),
                kyc_status: getKYCStatus(essrrliCustomerDetails?.KYC),
                segment: essrrliCustomerDetails.SEG_NAME,
                prefix: essrrliCustomerDetails.Prefix,
                cfname: essrrliCustomerDetails.Firstname,
                cmname: essrrliCustomerDetails.MiddleName,
                clname: essrrliCustomerDetails.Lastname,
                cphoneno: essrrliCustomerDetails.PhoneNo,
                cmobileno: essrrliCustomerDetails.OtherPhoneNo,
                cemail: essrrliCustomerDetails.BillEmail,
                bill_add1: essrrliCustomerDetails.Add1,
                bill_add2: essrrliCustomerDetails.Add2,
                bill_state: essrrliCustomerDetails.State,
                bill_district: essrrliCustomerDetails.District,
                bill_zipcode: essrrliCustomerDetails.Pincode,
                ship_to_name: essrrliCustomerDetails.ShipToName,
                sadd1: essrrliCustomerDetails.ShipAdd1,
                sadd2: essrrliCustomerDetails.ShipAdd2,
                ship_state: essrrliCustomerDetails.ShipState,
                ship_district: essrrliCustomerDetails.ShipDistrict,
                ship_zipcode: essrrliCustomerDetails.ShipPinCode,
                ship_title: essrrliCustomerDetails.ShipTitle,
                fname: essrrliCustomerDetails.ShipFirstname,
                mname: essrrliCustomerDetails.ShipMiddlename,
                lname: essrrliCustomerDetails.ShipLastname,
                phno: essrrliCustomerDetails.ShipPhoneNo,
                mob: essrrliCustomerDetails.ShipOtherPhoneNo,
                ship_co_email: essrrliCustomerDetails.ShipEmail,
                invoice_copy: essrrliCustomerDetails.InvCopies,
                credit_limit: essrrliCustomerDetails.CreditLimit,
                gst_no: essrrliCustomerDetails.Remarks ?? "",
                pan_no: essrrliCustomerDetails.PAN_NO ?? "",
                ship_gst_no: essrrliCustomerDetails.ShipToGSTN ?? "",
                trade_discount: "0.00",
                credit_hold: "N",
                app_per: true,
                kyc_check: true,
            });
        }
    }, [essrrliCustomerDetails, townList]);

    useEffect(() => {
        if (customerType == "DNA") {
            if(customerType == "DNA" && resType == "RSE"){
                setRseChecked(true);
            }
            formik.setValues({
                comments: "",
                name: dnaCustomerDetails?.OutletName,
                cfname: "",
                clname: "",
                pan_no: "",
                segment: dnaCustomerDetails?.SubSegmentDesc,
                creation_date: new Date(),
                cmobileno: dnaCustomerDetails?.OwnerMobileNo,
                trade_discount: "0.00",
                credit_hold: "N",
                app_per: true,
                kyc_check: true,
                employeeSelect: dnaCustomerDetails.DSRID
                    ? employeeList.find((val) => val.CODE === dnaCustomerDetails?.DSRID)
                    : null,
                day_of_beat1: dnaCustomerDetails.BeatDay
                    ? dayOfWeek.find(
                        (val) => val.CODE == dnaCustomerDetails?.BeatDay.toString(),
                    )
                    : null,
            });
        }
    }, [dnaCustomerDetails, dayOfWeek, employeeList]);

    const DNAcustomerList = (dnaId, Type = "RSE") => {
        const endpoint =
      Type === "RSE"
          ? `${Endpoint.GetUrbanList}?DBID=${auth.CompId}`
          : `${Endpoint.GetAwaitedDNAList}?DBID=${auth.CompId}&Status=Awaiting DB Confirmation`;

        createAPICustomerMastEndpoint()
            .get(endpoint)
            .then((response) => {
                let DNACust = response.data.filter((item) => {
                    return item.DNAID == dnaId;
                });
                setDnaCustomerDetails(DNACust[0]);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const GSTcustomerList = (getGstcustId) => {
    //   setLoading(true);
        createAPICustomerMastEndpoint()
            .get(`${Endpoint.PopulateGSTExistCustList}?CompId=${auth.CompId}`)
            .then((response) => {
                let gstCust = response.data.filter((item) => {
                    return item.CustomerID == getGstcustId;
                });
                setGstCustomerDetails(gstCust);
            })
            .catch((error) => {
                console.log(error);
                //   setLoading(false);
            });
    };

    console.log(gstCustomerDetails);
    const getKYCStatus = (kycCode) => {
        switch (kycCode) {
        case "N":
            return "Under Approval";
        case "T":
            return "Re-submitted";
        case "R":
            return "Rejected";
        case "S":
            return "Billing Stopped";
        case "A":
            return "Approved";
        case "P":
            return "Partially Complete";
        default:
            return "Not Applicable";
        }
    };

    const stateSegmentProps = {
        segmentPopup,
        setSegmentPopup,
        setSegmentValue,
        segmentValue,
        segmentStreamList,
        setManualSegmentEnterBtn,
        setsegStatus,
    };

    // console.log("segmentValue",segmentValue);

    const townHandleChange = async (e) => {
        setManualTownEnter(true);
        setBillZip([]);
        setBillDistrict([]);
        setBillState([]);
        if (e.target?.value?.GEOG_ID !== undefined) {
            setUniqueCodeBtn(true);
            setLoadinfdt(true);
            const town_dist = `${town_URL}CICode=${auth.CICode}&intGeogLevel=2&strGeogId=${e?.target?.value?.GEOG_ID}`;
            const dist_res = await Axios.get(town_dist);
            setBillDistrict(dist_res.data[0].NAME);
            // for state
            const geoIdForState = dist_res.data[0].CODE;
            const town_state = `${town_URL}CICode=${auth.CICode}&intGeogLevel=1&strGeogId=${geoIdForState}`;
            const state_res = await Axios.get(town_state);
            setBillState(state_res.data[0].NAME);
            // for pin
            const zip_api = `${zip_Search_URL}CICode=${auth.CICode}&strGeogId=${e.target?.value?.GEOG_ID}`;
            const zip_res = await Axios.get(zip_api);
            setBillZip(zip_res.data);
            //Unique Code
            const uniqueCode_api = `${uniqueCodeGen_URL}CICode=${auth.CICode}&ZipCode=${zip_res.data}&CompId=${auth.CompId}`;
            if (newCustomerSave) {
                const uniqueRes = await Axios.get(uniqueCode_api);
                setNewCustomerUniCode(uniqueRes.data);
                setUniqueCodeBtn(true);
            }
            setLoadinfdt(false);
        }
    };

    // console.log(formik, "formik");

    const isFormFieldInvalid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? (
            <small className="p-error">{formik.errors[name]}</small>
        ) : (
            <small className="p-error">&nbsp;</small>
        );
    };

    useEffect(() => {
        if (Object.keys(formik.errors).length !== 0) {
            toast.error(
                "Please fill all the mandatory field marked as (*) with valid Data",
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                },
            );
        }
    }, [formik.submitCount]);

    const handleCopyShipAdd = (e) => {
        if (e.value) {
            formik.setFieldValue("sadd1", formik.values.bill_add1);
            formik.setFieldValue("sadd2", formik.values.bill_add2);
        } else {
            formik.setFieldValue("sadd1", "");
            formik.setFieldValue("sadd2", "");
        }
        const isBillTownInShipTownList = !!shipTownList.find(
            (town) => town.MASK_GEOG_ID+"-"+town.TOWN+"-"+town.PIN_CODE === formik.values.bill_town.GEOG_ID+"-"+formik.values.bill_town.NAME+"-"+formik.values.bill_town.PIN_CODE,
        );
        // NO restriction for HD customers and ILS
        if (hdILScustomer) {
            if (e.value) {
                formik.setFieldValue("ship_town", formik.values.bill_town);
                formik.setFieldValue("ship_state", formik.values.bill_state);
                formik.setFieldValue("ship_district", formik.values.bill_district);
                formik.setFieldValue("ship_zipcode", formik.values.bill_zipcode);
                shipTownHandleChange(formik.values.bill_town, 2);
                formik.setFieldValue("copy_to_ship_address", e.value);
                setCopyToShip(true);
            }
        } else {
            if (!isBillTownInShipTownList) {
                toast.error("This Town doesn't not exist in Shipping Town", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                formik.setFieldValue("copy_to_ship_address", false);
                setCopyToShip(false);
            } else {
                if (e.value) {
                    // console.log("Data000", e.value);
                    formik.setFieldValue("ship_town", formik.values.bill_town);
                    formik.setFieldValue("ship_state", formik.values.bill_state);
                    formik.setFieldValue("ship_district", formik.values.bill_district);
                    formik.setFieldValue("ship_zipcode", formik.values.bill_zipcode);
                    shipTownHandleChange(formik.values.bill_town, 2);
                    formik.setFieldValue("copy_to_ship_address", e.value);
                    setCopyToShip(true);
                }
            }
        }
    };
    console.log(formik);

    const handleCopyShipCont = (e) => {
        formik.setFieldValue("copy_to_ship_contact", e.value);
        if (e.value) {
            formik.setFieldValue("ship_title", formik.values.prefix);
            formik.setFieldValue("fname", formik.values.cfname);
            formik.setFieldValue("mname", formik.values.cmname);
            formik.setFieldValue("lname", formik.values.clname);
            formik.setFieldValue("phno", formik.values.cphoneno);
            formik.setFieldValue("mob", formik.values.cmobileno);
            formik.setFieldValue("ship_co_email", formik.values.cemail);
        } else {
            formik.setFieldValue("ship_title", "");
            formik.setFieldValue("fname", "");
            formik.setFieldValue("mname", "");
            formik.setFieldValue("lname", "");
            formik.setFieldValue("phno", "");
            formik.setFieldValue("mob", "");
            formik.setFieldValue("ship_co_email", "");
        }
    };

    const shipTownHandleChange = async (e, id) => {
        const shipSalesArea_URL = "CustomerMast/GetShipSalesArea?";
        if (id == 1) {
            setManualShipEnter(true);
            setShipZip([]);
            setShipDistrict([]);
            setShipState([]);
            if (e.target?.value?.MASK_GEOG_ID !== undefined) {
                setShipDistrict(e.target.value?.DISTRICT);
                setShipZip(e.target.value?.PIN_CODE);
                setShipState(e.target.value?.STATE);
                const shipSalesArea_api = `${shipSalesArea_URL}CICode=${auth.CICode}&strShipAreaId=${e.target.value.MASK_GEOG_ID}`;
                const salesshipRes = await Axios.get(shipSalesArea_api);
                setShipSalesArea(salesshipRes?.data[0]?.MASK_AREA_ID);
            }
        } else if (id == 2) {
            // console.log("Data000", e);
            if (e.GEOG_ID !== undefined) {
                const shipSalesArea_api = `${shipSalesArea_URL}CICode=${auth.CICode}&strShipAreaId=${e.GEOG_ID}`;
                const salesshipRes = await Axios.get(shipSalesArea_api);
                setShipSalesArea(salesshipRes?.data[0]?.MASK_AREA_ID);
                // setBillAddressLoader(false);
            }
        }
    };

    const handleshipsalesArea = async (GEOG_ID) => {
        const shipSalesArea_URL = "CustomerMast/GetShipSalesArea?";
        const shipSalesArea_api = `${shipSalesArea_URL}CICode=${auth.CICode}&strShipAreaId=${GEOG_ID}`;
        const salesshipRes = await Axios.get(shipSalesArea_api);
        setShipSalesArea(salesshipRes?.data[0]?.MASK_AREA_ID);
    };
    const TownTemplate = (townFilter) => {
        return (
            <>
                {townFilter.PIN_CODE}-{townFilter.NAME}
            </>
        );
    };
    const ShipTownTemplate = (townFilter) => {
        return (
            <>
                {townFilter.PIN_CODE}-{townFilter.TOWN}
            </>
        );
    };
    const PayTermTaxAreaTemplate = (stateFilter) => {
        return (
            <>
                {stateFilter.CODE} - {stateFilter.NAME}
            </>
        );
    };
    const tcsDropDownlistTemplate = (stateFilter) => {
        return <>{stateFilter.TAX_PERCENTAGE}</>;
    };

    const procedFurther = () => {
        setPhoneValidationPopUp(false);
        customerMasterSave(customerDetailsData);
    };

    const handleFileChangecustphoto = (event) => {
    // debugger;
        const file = event.target.files[0];
        formik.setFieldValue("cust_url", file);
    };
    const handleFileChangestorephoto = (event) => {
        const file = event.target.files[0];
        formik.setFieldValue("cust_store", file);
    };

    // console.log(pandataverify);

    const customerMasterSave = async (obj1) => {
    // debugger;
    // setCustomerSaveUpdateLoader(true);
    // console.log("obj1", obj1);
    // return;
        const saveCustomerMaster_URL = "CustomerMast/SaveCustomerDetails";

        const creation_date =
      obj1?.creation_date == undefined ||
      obj1?.creation_date == null ||
      obj1?.creation_date == ""
          ? format(new Date(), "dd/MM/yyyy")
          : format(obj1?.creation_date, "dd/MM/yyyy");
        const expiry_date =
      obj1?.expiry_date == undefined ||
      obj1?.expiry_date == null ||
      obj1?.expiry_date == ""
          ? ""
          : format(obj1?.expiry_date, "dd/MM/yyyy");
        // debugger;
        // edit customer master payload

        // console.log(creation_date);
        // console.log(expiry_date);
        // debugger;

        // console.log(customerDetailsById.strPANDetails[5],"ppp000");
        // console.log(customerDetailsById.strPANDetails,"ppp000");

        if (
            (customerType == "newcust" ||
        customerType == "RLIESSR" ||
        customerType == "DNA") &&
      !panverifysuccess &&
      obj1?.pan_no?.length > 1
        ) {
            toast.warn("Please Verify the PAN Number before proceed", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            setDisabledbtn(false);
            return;
        }

        if (customerType == "Gstvcust" || customerType == "normal") {
            if (customerType == "normal") {
                if (customerDetailsById.strPANDetails[5] == "V") {
                    if (
                        customerDetailsById.strPANDetails[5] == "V" &&
            obj1.pan_no == ""
                    ) {
                        toast.warning(
                            "Please enter a valid PAN or previously entered verified PAN with respective name to save the customer.",
                            {
                                position: toast.POSITION.TOP_CENTER,
                                pauseOnFocusLoss: false,
                                closeButton: false,
                                autoClose: 4000,
                            },
                        );
                        setDisabledbtn(false);
                        return;
                    }
                    if (
                        customerDetailsById.Firstname !== obj1.cfname ||
            customerDetailsById.Lastname !== obj1.clname ||
            customerDetailsById.PAN_NO !== obj1.pan_no ||
            customerDetailsById.Name !== obj1.name
                    ) {
                        if (!panverifysuccess) {
                            toast.warning(
                                "KYC field change, Please Verify the PAN Number before proceed",
                                {
                                    position: toast.POSITION.TOP_CENTER,
                                    pauseOnFocusLoss: false,
                                    closeButton: false,
                                    autoClose: 2000,
                                },
                            );
                            setDisabledbtn(false);
                            return;
                        }
                    }
                } else {
                    if (!panverifysuccess && obj1?.pan_no?.length > 1) {
                        toast.warn("Please Verify the PAN Number before proceed", {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 3000,
                        });
                        setDisabledbtn(false);
                        return;
                    }
                }
            } else if (customerType == "Gstvcust") {
                if (customerDetailsByIdGST.strPANDetails[5] == "V") {
                    if (
                        customerDetailsByIdGST.Firstname != obj1.cfname &&
            customerDetailsByIdGST.Lastname != obj1.clname &&
            customerDetailsByIdGST.PAN_NO != obj1.pan_no &&
            customerDetailsByIdGST.Name != obj1.name
                    ) {
                        if (!panverifysuccess) {
                            toast.warning(
                                "KYC field change, Please Verify the PAN Number before proceed",
                                {
                                    position: toast.POSITION.TOP_CENTER,
                                    pauseOnFocusLoss: false,
                                    closeButton: false,
                                    autoClose: 2000,
                                },
                            );
                            setDisabledbtn(false);
                            return;
                        }
                    }
                } else {
                    if (!panverifysuccess && obj1?.pan_no?.length > 1) {
                        toast.warn("Please Verify the PAN Number before proceed", {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 3000,
                        });
                        setDisabledbtn(false);
                        return;
                    }
                }
            }
        }

        const StrShip = [
            obj1.ship_title ?? "",
            obj1.fname ?? "",
            obj1.mname ?? "",
            obj1.lname ?? "",
            obj1.phno ?? "",
            obj1.mob ?? "",
            obj1.sadd1 ?? "",
            obj1.sadd2 ?? "",
            obj1.ship_town?.TOWN ?? "",
            obj1.ship_co_email ?? "",
        ];
        let addnewSaveObj = {};
        let editsaveobj = {};
        let editDNACutomerdeatils = {};
        let editessrCustdeatils = {};
        let editGSTCustdeatils = {};

        if (customerType == "newcust") {
            // add new customer master payload
            addnewSaveObj = {
                ciCode: auth.CICode, // send blank for insert
                custId: "", // blank for insert
                urbanTag:rsechecked?"Y":"N",
                compid: auth.CompId,
                creditHold: obj1.credit_hold,
                custGstin: obj1.gst_no,
                uniqueCode: obj1.unique_code,
                tinno: obj1.tin_no,
                paN_NO: obj1.pan_no,
                taxForm: "", // disabled for insert
                kyc: "", //obj1.kyc_status ? "Y" : "N",
                aadharno: obj1.caadhar ?? "",
                imageUrl: "",
                custPhoto: "",
                specialCode: "",
                employee: `${obj1.employeeSelect.MASK_ID}~${obj1.employeeSelect.MASK_EMP_ID}~${obj1.employeeSelect.CODE}~${obj1.employeeSelect.NAME}`,
                permission: true,
                userId: auth.UserId,
                partyId: "", // customerDetailsById.PartyId,
                maxOrderVal: obj1.max_order ?? "",
                remarks: obj1.gst_no, // add bill gst "GSTNo"
                creditLimit: obj1.credit_limit,
                billingIns: obj1.billing_inst,
                invCopies: "0",
                custdeliveryInst: obj1.delivery_inst,
                priority: obj1.priority ?? "",
                privilege: "", // send blank
                docDiscount: obj1.trade_discount,
                taxAreaId: obj1.tax_area.MASK_AREA_ID,
                taxArea: `${obj1.tax_area.MASK_AREA_ID}~${obj1.tax_area.CODE}~${obj1.tax_area.NAME}`,
                payTermId: obj1.payment_term.MASK_PAY_TERM_ID,
                payTerm: `${obj1.payment_term.MASK_PAY_TERM_ID}~${obj1.payment_term.CODE}~${obj1.payment_term.NAME}`,
                payModeId: obj1.payment_mode.MASK_MOP_ID,
                modeOfPayment: `${obj1.payment_mode.MASK_MOP_ID}~${obj1.payment_mode.CODE}~${obj1.payment_mode.NAME}`,
                currencyId: "",
                currencyName: "",
                vanrtId: obj1?.van_route?.MASK_VAN_RT_ID ?? "",

                gstNo: obj1.gst_no,
                // geogId: obj1.ship_town.MASK_GEOG_ID,
                segId: segmentValue.SBSD_ID ?? "",
                displaySeq: "",
                segment: segmentValue.SEG_DESC ?? "",
                seG_NAME: segmentValue.SEG_DESC ?? "",
                allchkmId: "G_BIGS_NA-2|G", //send hard coded
                salesAreaId: shipSalesArea ?? "", // call api GetShipSalesArea
                minOrderVal: obj1.min_order ?? "",
                lat: obj1?.latitude?.toString(),
                long: obj1?.longitude?.toString(),
                insertUpdate: "1", //1 for insert 2 for update
                salesexecutiveId: "", // send blank
                transportChargeId: "", //  send blank
                transportCharges: obj1.transport_charges ?? "",
                creationDate: creation_date,
                expiryDate: expiry_date ?? "",
                compstate: compState ?? "",
                taxPercentageRate: "",
                insertUpdateBill: "1",
                prefferedDay: obj1?.p_day_of_delivery?.id,
                dayOfWeek: `${obj1.day_of_beat1.CODE}~${obj1.day_of_beat1.NAME}`,
                deliveryDay1: "", //send blank
                deliveryDay2: "", //send blank
                frequency: `${obj1.beat_frequency.MASK_FREQUENCY_ID}~${obj1.beat_frequency.CODE}~${obj1.beat_frequency.NAME}`,
                beatFrequency: "", //send blank
                startWeek: "", //send blank
                beat2: "", //send blank
                shipSerialNo: "1", // send 1 always
                shipTitle: obj1.ship_title,
                shipFirstname: obj1.fname,
                shipMiddlename: obj1.mname,
                shipLastname: obj1.lname,
                shipEmail: obj1.ship_co_email,
                shipFax: "", // send blank
                shipToGSTN: "",
                shipToName: obj1.ship_to_name,
                shipSTD: "", // send blank
                shipPhoneNo: obj1.phno,
                shipOtherPhoneNo: obj1.mob,
                shipAdd1: obj1.sadd1,
                shipAdd2: obj1.sadd2,
                shipState: obj1.ship_state,
                shipTown: copyToShip
                    ? obj1.ship_town.NAME
                    : (obj1.ship_town.TOWN ?? ""),
                shipDistrict: obj1.ship_district,
                shipPinCode: obj1.ship_zipcode,
                salesArea: shipSalesArea ?? "", //call api GetShipSalesArea
                shipGeogId: copyToShip
                    ? obj1.ship_town.GEOG_ID
                    : obj1.ship_town.MASK_GEOG_ID,
                shipSalesExecutive: obj1.employeeSelect.NAME ?? "", // employee Name drop down
                shipSalesExecutiveId: obj1.employeeSelect.MASK_EMP_ID ?? "", // employeeID drop down
                shipStatus: "Y", // plesae add chechbox
                vanRt: obj1?.van_route?.NAME ?? "",
                insertUpdateShip: "1", // 2 for update 1 for insert
                taxFormId: "", // send blank
                prefix: obj1.prefix,
                firstname: obj1.cfname,
                middleName: obj1.cmname,
                lastname: obj1.clname,
                stdCode: "",
                phoneNo: obj1.cphoneno,
                otherPhoneNo: obj1.cmobileno,
                add1: obj1.bill_add1,
                add2: obj1.bill_add2,
                district: obj1.bill_district,
                state: obj1.bill_state,
                town: obj1.bill_town.NAME ?? "",
                email: obj1.cemail,
                accountId: "", //send blank
                code: "",
                name: obj1.name,
                ledgerId: "", //send blank
                ledgerName: "", //send blank
                retailTag: "", //send blank
                fax: "", //send blank
                pincode: obj1.bill_zipcode,
                active: obj1.active_check ? "Y" : "N", // bind check status
                chkActive: false, // send false
                distTag: auth.DistTag,
                status: obj1.kyc_status ? "Y" : "N",
                salesValue: "", // send blank
                tradeDiscount: obj1.trade_discount,
                appPermission: obj1.app_per ? true : false, // set on basis of user check
                // strGeogId: obj1.bill_town.GEOG_ID,
                billTitle: obj1.prefix,
                billFirstname: obj1.cfname,
                billMiddlename: obj1.cmname,
                billLastname: obj1.clname,
                billSerialNo: "1", // always 1
                billAdd1: obj1.bill_add1,
                billAdd2: obj1.bill_add2,
                billEmail: obj1.cemail,
                billFax: "", //send blank
                billPhoneNo: obj1.cphoneno,
                billOtherPhoneNo: obj1.cmobileno,
                billGeogId: obj1.bill_town.GEOG_ID ?? "",
                billTown: obj1.bill_town.NAME ?? "",
                billDistrict: obj1.bill_district,
                billState: obj1.bill_state,
                billPinCode: obj1.bill_zipcode,
                billStatus: "Y", // bind check status
                eInvApplicability: auth.EInvApplicability,
                eInvIRPUserId: auth.EInvIRPUserId,
                eInvIRPUserPassword: auth.EInvIRPUserPassword,
                eInvGSTNO: auth.EInvGSTNO,
                strcustkyc: "", //send blank
                strPANDetails: panverifysuccess
                    ? [
                        obj1.name ?? "",
                        obj1.cfname ?? "",
                        obj1.cmname ?? "",
                        obj1.clname ?? "",
                        obj1.pan_no ?? "",
                        "V",
                        null,
                    ]
                    : null,
                _arrPANDtl: panverifysuccess ? storeVerifydata : null,
                mobile: obj1.cmobileno, //  add bill_otherphone
                isTCSApplicable: "", //send blank
                comments: obj1.comments ?? "",
                hdDist: getHDDistStatus ?? "",
                isILSHDUser: hdILScustomer,
            };
        } else if (customerType == "normal") {
            let isChanged = "";
            if (
                customerDetailsById.KYC == "A" ||
        customerDetailsById.KYC == "T" ||
        customerDetailsById.KYC == "R" ||
        customerDetailsById.KYC == "S"
            ) {
                if (
                    customerDetailsById.Firstname === obj1.cfname &&
          customerDetailsById.Lastname === obj1.clname &&
          customerDetailsById.Add1 === obj1.bill_add1 &&
          customerDetailsById.Add2 === obj1.bill_add2 &&
          customerDetailsById.BillPinCode === obj1.bill_zipcode &&
          customerDetailsById.OtherPhoneNo === obj1.cmobileno
                ) {
                    isChanged = "N";
                } else {
                    isChanged = "Y";
                }
            }

            // const StrData = [
            //     customerDetailsById.AllchkmId, //0
            //     customerDetailsById.CurrencyId,//1
            //     customerDetailsById.ModeOfPayment,//2
            //     customerDetailsById.PayTermId, //3
            //     customerDetailsById.SalesAreaId,//4
            //     customerDetailsById.SalesexecutiveId,//5
            //     manualSegmentEnterBtn
            //         ? segmentValue.SBSD_ID
            //         : segmentForEdit[0].MASK_SEG_ID, //customerDetailsById.SegId //6
            //     customerDetailsById.TaxAreaId,//7
            //     customerDetailsById.TaxFormId,//8
            //     // "711401000110001",  //change on 19/03/2025 as per Arijit da
            //     customerDetailsById.VanrtId ?? "",//9
            //     // obj1?.van_route?.MASK_VAN_RT_ID ?? "",
            //     customerDetailsById.TransportChargeId,//10
            //     "Y", //11
            //     customerDetailsById.ExpiryDate, //12
            //     customerDetailsById.TradeDiscount, //13
            //     customerDetailsById.CreditHold, //14
            //     customerDetailsById.CreditLimit, //15
            //     customerDetailsById.MaxOrderVal,//16
            //     customerDetailsById.MinOrderVal,//17
            //     customerDetailsById.InvCopies,//18
            //     customerDetailsById.CustdeliveryInst,//19
            //     customerDetailsById.BillingIns,//20
            //     customerDetailsById.GSTNo,//21 //remarks
            //     "", // doubt
            //     "", // doubt
            //     "", //doubt
            //     customerDetailsById.Priority,
            //     "Y", //EXPORT_TO_CDR_TAG
            //     customerDetailsById.Prefix,
            //     customerDetailsById.Firstname,
            //     customerDetailsById.MiddleName,
            //     customerDetailsById.Lastname,
            //     customerDetailsById.StdCode,
            //     customerDetailsById.PhoneNo,
            //     customerDetailsById.OtherPhoneNo,
            //     customerDetailsById.Add1,
            //     customerDetailsById.Add2,
            //     customerDetailsById.Town,
            //     customerDetailsById.TINNO,
            //     customerDetailsById.Email,
            // ];
            editsaveobj = {
                SMSROWENTRY: [],
                CICode: auth.CICode,
                CustId: custId,
                urbanTag:rsechecked?"Y":"N",
                IsTCSApplicable: customerDetailsById.IsTCSApplicable ?? "",
                Compid: auth.CompId,
                CreditHold: obj1.credit_hold,
                CustGstin: customerDetailsById.CustGstin ?? "",
                UniqueCode: obj1.unique_code ?? "",
                TINNO: obj1.tin_no ?? "",
                PAN_NO: obj1.pan_no ?? "",
                TaxForm: customerDetailsById.TaxForm,
                KYC: obj1.kyc_status,
                AADHARNO: obj1.caadhar ?? "",
                ImageUrl: "",
                CustPhoto: "",
                CustImage: [""],
                CustStore: "",
                StoreImage: [""],
                SpecialCode: "",
                Employee: `${obj1.employeeSelect.MASK_ID}~${obj1.employeeSelect.MASK_EMP_ID}~${obj1.employeeSelect.CODE}~${obj1.employeeSelect.NAME}`,
                Permission: obj1.app_per ? true : false,
                UserId: auth.UserId,
                PartyId: customerDetailsById.PartyId,
                maxOrderVal: obj1.max_order,
                Remarks: obj1.gst_no,
                GSTN_VERIFIED:
          customerDetailsById?.GSTN_VERIFIED == "Y"
              ? "Verified"
              : (customerDetailsById?.GSTN_VERIFIED ?? "" ?? ""),
                CreditLimit: obj1.credit_limit,
                BillingIns: obj1.billing_inst,
                InvCopies: "0",
                CustdeliveryInst: obj1.delivery_inst,
                Priority: obj1.priority ?? "",
                Privilege: customerDetailsById.Privilege,
                DocDiscount: obj1.trade_discount,
                TaxAreaId: obj1.tax_area.MASK_AREA_ID ?? "",
                TaxArea: `${obj1.tax_area.MASK_AREA_ID}~${obj1.tax_area.CODE}~${obj1.tax_area.NAME}`,
                PayTermId: obj1.payment_term.MASK_PAY_TERM_ID,
                PayTerm: `${obj1.payment_term.MASK_PAY_TERM_ID}~${obj1.payment_term.CODE}~${obj1.payment_term.NAME}`,
                PayModeId: obj1.payment_mode.MASK_MOP_ID,
                ModeOfPayment: `${obj1.payment_mode.MASK_MOP_ID}~${obj1.payment_mode.CODE}~${obj1.payment_mode.NAME}`,
                CurrencyId: customerDetailsById.CurrencyId ?? "",
                CurrencyName: customerDetailsById.CurrencyName ?? "",
                VanrtId: obj1?.van_route?.MASK_VAN_RT_ID ?? "",
                GSTNo: obj1.gst_no,
                SegId: manualSegmentEnterBtn
                    ? segmentValue.SBSD_ID
                    : segmentForEdit[0].MASK_SEG_ID, //customerDetailsById.SegId
                DisplaySeq: "",
                Segment: manualSegmentEnterBtn
                    ? segmentValue.SEG_DESC
                    : segmentForEdit[0].MASK_SEG_DESC, //customerDetailsById.Segment
                SEG_NAME: manualSegmentEnterBtn
                    ? segmentValue.SEG_DESC
                    : segmentForEdit[0].MASK_SEG_DESC, //customerDetailsById.Segment
                AllchkmId: customerDetailsById.AllchkmId ?? "",
                SalesAreaId: customerDetailsById.SalesAreaId ?? "", // call api GetShipSalesArea
                MinOrderVal: obj1.min_order,
                Lat: obj1?.latitude?.toString(),
                Long: obj1?.longitude?.toString(),
                InsertUpdate: "2", //1 for insert 2 for update
                // SalesexecutiveId: customerDetailsById.SalesexecutiveId,
                SalesexecutiveId: obj1.employeeSelect.MASK_EMP_ID,
                TransportChargeId: customerDetailsById.TransportChargeId,
                TransportCharges: obj1.transport_charges,
                CreationDate: creation_date,
                ExpiryDate: expiry_date,
                Compstate: customerDetailsById.Compstate,
                TaxPercentageRate: showTCSdropdown
                    ? (selectedTCS?.TAX_PERCENTAGE.toString() ?? "")
                    : "",
                InsertUpdateBill: "2",
                PrefferedDay: obj1.p_day_of_delivery.id,
                DayOfWeek: `${obj1.day_of_beat1.CODE}~${obj1.day_of_beat1.NAME}`,
                DeliveryDay1: customerDetailsById.DeliveryDay1, //send blank
                DeliveryDay2: customerDetailsById.DeliveryDay1, //send blank
                Frequency: `${obj1.beat_frequency.MASK_FREQUENCY_ID}~${obj1.beat_frequency.CODE}~${obj1.beat_frequency.NAME}`,
                BeatFrequency: obj1.beat_frequency.NAME,
                StartWeek: customerDetailsById.StartWeek,
                Beat2: customerDetailsById.Beat2,
                ShipSerialNo: customerDetailsById.ShipSerialNo,
                ShipTitle: obj1.ship_title ?? "",
                ShipFirstname: obj1.fname ?? "",
                ShipMiddlename: obj1.mname ?? "",
                ShipLastname: obj1.lname ?? "",
                ShipEmail: obj1.ship_co_email ?? "",
                ShipFax: customerDetailsById.ShipFax ?? "",
                ShipToGSTN: obj1.ship_gst_no ?? "",
                ShipToName: obj1.ship_to_name ?? "",
                ShipSTD: customerDetailsById.ShipSTD ?? "", // send blank
                ShipPhoneNo: obj1.phno ?? "",
                ShipOtherPhoneNo: obj1.mob ?? "",
                ShipAdd1: obj1.sadd1 ?? "",
                ShipAdd2: obj1.sadd2 ?? "",
                ShipState: obj1.ship_state ?? "",
                ShipTown: copyToShip
                    ? obj1.ship_town.NAME
                    : (obj1.ship_town.TOWN ?? ""),
                ShipDistrict: obj1.ship_district ?? "",
                ShipPinCode: obj1.ship_zipcode ?? "",
                SalesArea: customerDetailsById.SalesArea,
                ShipGeogId: copyToShip
                    ? obj1.ship_town.GEOG_ID
                    : (obj1.ship_town.MASK_GEOG_ID ?? ""),
                ShipSalesExecutive: obj1.employeeSelect.NAME, // employee Name drop down
                ShipSalesExecutiveId: obj1.employeeSelect.MASK_EMP_ID, // employeeID drop down
                ShipStatus: "Y", // plesae add chechbox
                VanRt: obj1?.van_route?.NAME ?? "",
                InsertUpdateShip: "2", // 2 for update 1 for insert
                DTShippingOldData: customerDetailsById.DTShippingOldData,
                TaxFormId: customerDetailsById.TaxFormId,
                Prefix: obj1.prefix,
                Firstname: obj1.cfname,
                MiddleName: obj1.cmname,
                Lastname: obj1.clname,
                StdCode: "",
                PhoneNo: obj1.cphoneno,
                OtherPhoneNo: obj1.cmobileno,
                Add1: obj1.bill_add1,
                Add2: obj1.bill_add2,
                District: obj1.bill_district,
                State: obj1.bill_state,
                Town: obj1.bill_town.NAME,
                Email: obj1.cemail,
                // Str: StrData,
                Str: customerDetailsById.Str,
                accountId: customerDetailsById.AccountId,
                Code: customerDetailsById.Code,
                Name: obj1.name,
                LedgerId: customerDetailsById.LedgerId,
                LedgerName: customerDetailsById.LedgerName,
                RetailTag: customerDetailsById.RetailTag,
                Fax: customerDetailsById.Fax,
                Pincode: obj1.bill_zipcode ?? "",
                Active: "Y", // bind check status
                // Active: "Y", // bind check status
                ChkActive: false, // send false
                DistTag: auth.DistTag,
                Status: obj1.kyc_check ? "Y" : "N",
                SalesValue: customerDetailsById.SalesValue,
                TradeDiscount: obj1.trade_discount,
                AwaitedRILDetails: customerDetailsById.AwaitedRILDetails,
                AppPermission: obj1.app_per ? true : false,
                BillTitle: obj1.prefix,
                BillFirstname: obj1.cfname,
                BillMiddlename: obj1.cmname,
                BillLastname: obj1.clname,
                BillSerialNo: "1", // always 1
                BillAdd1: obj1.bill_add1,
                BillAdd2: obj1.bill_add2,
                BillEmail: obj1.cemail,
                BillFax: "", //send blank
                BillPhoneNo: obj1.cphoneno,
                BillOtherPhoneNo: obj1.cmobileno,
                BillGeogId: obj1.bill_town.GEOG_ID,
                BillTown: obj1.bill_town.NAME,
                BillDistrict: obj1.bill_district,
                BillState: obj1.bill_state,
                BillPinCode: obj1.bill_zipcode,
                BillStatus: "Y", // bind check status
                DSBillData: customerDetailsById.DSBillData,
                DSShipData: customerDetailsById.DSShipData,
                EInvApplicability: auth.EInvApplicability,
                EInvIRPUserId: auth.EInvIRPUserId,
                EInvIRPUserPassword: auth.EInvIRPUserPassword,
                EInvGSTNO: auth.EInvGSTNO,
                // EInvGSTNO: Decrypt((auth.EInvGSTNO).toString()),
                Strcustkyc: customerDetailsById.strcustkyc, //send blank
                strPANDetails: customerDetailsById.strPANDetails,
                strship: customerDetailsById.strship,
                _arrPANDtl: panverifysuccess ? storeVerifydata : null,
                Mobile: obj1.cmobileno,
                dgDistDiscount: customerDetailsById.dgDistDiscount,
                strTrSuppTag: customerDetailsById.strTrSuppTag,
                // strTrSuppTag: customerDetailsById.strTrSuppTag,
                strTrCustTag: customerDetailsById.strTrCustTag,
                strNtrCustTag: customerDetailsById.strNtrCustTag,
                strDefinedBy: customerDetailsById.strDefinedBy,
                strCustCount: customerDetailsById.strCustCount,
                strSuppCount: customerDetailsById.strSuppCount,
                AlchemyName: customerDetailsById.AlchemyName,
                RecordDefinedBy: customerDetailsById.RecordDefinedBy,
                AwaitedDNADetails: customerDetailsById.AwaitedDNADetails,
                IsKYCApproved: isChanged,
                comments: obj1.comments,
                hdDist: getHDDistStatus ?? "",
                isILSHDUser: hdILScustomer,
            };

            let ExcelUploadUrl = "CustomerMast/UploadCustImage";

            if (isB2bcust) {
                if (obj1?.cust_url !== null) {
                    let arrphotofile = obj1?.cust_url;
                    // console.log("chking photo", obj1.cust_viewurl);
                    // console.log("arrphotofile", arrphotofile);
                    const formFile = new FormData();
                    formFile.append("CICode", auth.CICode);
                    formFile.append("CustId", encodeURIComponent(custIdparam).toString());
                    formFile.append("CompId", auth.CompId);
                    formFile.append("filelist", arrphotofile);
                    formFile.append("fileType", "Customer_Identity");
                    formFile.append("CustPhoto", obj1.cust_viewurl ?? "");
                    formFile.append("CustStore", "");
                    formFile.append("CustImage", [""]);
                    formFile.append("UserId", auth.UserId);
                    formFile.append("IUKey", "1");
                    try {
                        let response = await AxiosExcel.post(
                            `${ExcelUploadUrl}`,
                            formFile,
                            {
                                headers: { "Content-Type": "multipart/form-data" },
                            },
                        );
                        console.log(response);
                    } catch (err) {
                        console.log(err);
                    }
                }
                if (obj1?.cust_store !== null) {
                    let arrphotlist = obj1?.cust_store;
                    const formFile = new FormData();
                    formFile.append("CICode", auth.CICode);
                    formFile.append("CustId", encodeURIComponent(custIdparam).toString());
                    formFile.append("CompId", auth.CompId);
                    formFile.append("filelist", arrphotlist);
                    formFile.append("fileType", "Customer_Store");
                    formFile.append("CustPhoto", "");
                    formFile.append("CustStore", obj1.cust_viewstore ?? "");
                    formFile.append("CustImage", [""]);
                    formFile.append("UserId", auth.UserId);
                    formFile.append("IUKey", "1");
                    try {
                        let response = await AxiosExcel.post(
                            `${ExcelUploadUrl}`,
                            formFile,
                            {
                                headers: { "Content-Type": "multipart/form-data" },
                            },
                        );
                        console.log(response);
                    } catch (err) {
                        console.log(err);
                    }
                }
            }
        } else if (customerType == "RLIESSR") {
            //edit ESSRRLI List Data
            const StrDataforESSR = [
                "G_BIGS_NA-2|G",
                "", //currency ID
                obj1.payment_mode.MASK_MOP_ID ?? "",
                obj1.payment_term.MASK_PAY_TERM_ID ?? "",
                shipSalesArea ?? "",
                "", //SalesexecutiveId
                essrrliCustomerDetails.SegId ?? "",
                obj1.tax_area.MASK_AREA_ID ?? "",
                "", //TaxFormId
                // "711401000110001", //change on 19/03/2025 as per Arijit da
                obj1?.van_route?.MASK_VAN_RT_ID ?? "",
                "", //TransportChargeId
                "Y",
                expiry_date,
                obj1.trade_discount ?? "",
                obj1.credit_hold ? "Y" : "N",
                obj1.credit_limit ?? "",
                obj1.max_order ?? "",
                obj1.min_order ?? "",
                obj1.invoice_copy ?? "",
                obj1.delivery_inst ?? "",
                obj1.billing_inst ?? "",
                obj1.gst_no ?? "",
                "", // doubt
                "", // doubt
                "", //doubt
                obj1.priority ?? "",
                "",
                obj1.prefix ?? "",
                obj1.cfname ?? "",
                obj1.cmname ?? "",
                obj1.clname ?? "",
                "", //STD code
                obj1.cphoneno ?? "",
                obj1.cmobileno ?? "",
                obj1.bill_add1 ?? "",
                obj1.bill_add2 ?? "",
                obj1.bill_town.NAME ?? "",
                obj1.tin_no ?? "",
                obj1.cemail ?? "",
            ];

            editessrCustdeatils = {
                SMSROWENTRY: [],
                CICode: auth.CICode,
                CustId: "",
                urbanTag:rsechecked?"Y":"N",
                IsTCSApplicable: "",
                Compid: auth.CompId,
                CreditHold: obj1.credit_hold,
                CustGstin: obj1.gst_no ?? "",
                UniqueCode: obj1.unique_code ?? "",
                TINNO: obj1.tin_no ?? "",
                PAN_NO: obj1.pan_no ?? "",
                TaxForm: "",
                KYC: obj1.kyc_status ?? "",
                AADHARNO: obj1.caadhar ?? "",
                ImageUrl: "",
                CustPhoto: "",
                CustImage: [""],
                CustStore: "",
                StoreImage: [""],
                SpecialCode: "",
                Employee: `${obj1.employeeSelect.MASK_ID}~${obj1.employeeSelect.MASK_EMP_ID}~${obj1.employeeSelect.CODE}~${obj1.employeeSelect.NAME}`,
                Permission: obj1.app_per ? true : false,
                UserId: auth.UserId,
                PartyId: "",
                maxOrderVal: obj1.max_order ?? "",
                Remarks: obj1.gst_no ?? "",
                CreditLimit: obj1.credit_limit ?? "",
                BillingIns: obj1.billing_inst ?? "",
                InvCopies: "0",
                CustdeliveryInst: obj1.delivery_inst ?? "",
                Priority: obj1.priority ?? "",
                Privilege: "",
                DocDiscount: obj1.trade_discount ?? "",
                TaxAreaId: obj1.tax_area.MASK_AREA_ID,
                TaxArea: `${obj1.tax_area.MASK_AREA_ID}~${obj1.tax_area.CODE}~${obj1.tax_area.NAME}`,
                PayTermId: obj1.payment_term.MASK_PAY_TERM_ID,
                PayTerm: `${obj1.payment_term.MASK_PAY_TERM_ID}~${obj1.payment_term.CODE}~${obj1.payment_term.NAME}`,
                PayModeId: obj1.payment_mode.MASK_MOP_ID,
                ModeOfPayment: `${obj1.payment_mode.MASK_MOP_ID}~${obj1.payment_mode.CODE}~${obj1.payment_mode.NAME}`,
                CurrencyId: "",
                CurrencyName: "",
                VanrtId: obj1?.van_route?.MASK_VAN_RT_ID ?? "",
                GSTNo: obj1.gst_no,
                SegId: essrrliCustomerDetails.SegId,
                DisplaySeq: "",
                Segment: essrrliCustomerDetails.SEG_NAME ?? "",
                SEG_NAME: essrrliCustomerDetails.SEG_NAME ?? "",
                AllchkmId: "G_BIGS_NA-2|G",
                SalesAreaId: shipSalesArea ?? "", // call api GetShipSalesArea
                MinOrderVal: obj1.min_order ?? "",
                Lat: obj1?.latitude?.toString() ?? "",
                Long: obj1?.longitude?.toString() ?? "",
                InsertUpdate: "1", //1 for insert 2 for update
                SalesexecutiveId: "",
                TransportChargeId: "",
                TransportCharges: obj1.transport_charges ?? "",
                CreationDate: creation_date,
                ExpiryDate: expiry_date,
                Compstate: compState,
                TaxPercentageRate: "", //customerDetailsById.TaxPercentageRate, //need to discuss ("")(api call gettcscust)
                InsertUpdateBill: "1",
                PrefferedDay: obj1.p_day_of_delivery.id,
                DayOfWeek: `${obj1.day_of_beat1.CODE}~${obj1.day_of_beat1.NAME}`,
                DeliveryDay1: "", //send blank
                DeliveryDay2: "", //send blank
                Frequency: `${obj1.beat_frequency.MASK_FREQUENCY_ID}~${obj1.beat_frequency.CODE}~${obj1.beat_frequency.NAME}`,
                BeatFrequency: obj1.beat_frequency.NAME,
                StartWeek: "",
                Beat2: "",
                ShipSerialNo: "1", // from UI which is missing
                ShipTitle: obj1.ship_title ?? "",
                ShipFirstname: obj1.fname ?? "",
                ShipMiddlename: obj1.mname ?? "",
                ShipLastname: obj1.lname ?? "",
                ShipEmail: obj1.ship_co_email ?? "",
                ShipFax: "",
                ShipToGSTN: obj1.ship_gst_no ?? "",
                ShipToName: obj1.ship_to_name ?? "",
                ShipSTD: "", // send blank
                ShipPhoneNo: obj1.phno ?? "",
                ShipOtherPhoneNo: obj1.mob ?? "",
                ShipAdd1: obj1.sadd1 ?? "",
                ShipAdd2: obj1.sadd2 ?? "",
                ShipState: obj1.ship_state,
                ShipTown: copyToShip
                    ? obj1.ship_town.NAME
                    : (obj1.ship_town.TOWN ?? ""),
                ShipDistrict: obj1.ship_district,
                ShipPinCode: obj1.ship_zipcode,
                SalesArea: shipSalesArea, // api call
                ShipGeogId: copyToShip
                    ? obj1.ship_town.GEOG_ID
                    : obj1.ship_town.MASK_GEOG_ID,
                ShipSalesExecutive: obj1.employeeSelect.NAME, // employee Name drop down
                ShipSalesExecutiveId: obj1.employeeSelect.MASK_EMP_ID, // employeeID drop down
                ShipStatus: "Y", // plesae add chechbox
                VanRt: obj1?.van_route?.NAME ?? "",
                InsertUpdateShip: "1", // 2 for update 1 for insert
                DTShippingOldData: null,
                TaxFormId: "",
                Prefix: obj1.prefix ?? "",
                Firstname: obj1.cfname ?? "",
                MiddleName: obj1.cmname ?? "",
                Lastname: obj1.clname ?? "",
                StdCode: "",
                PhoneNo: obj1.cphoneno ?? "",
                OtherPhoneNo: obj1.cmobileno ?? "",
                Add1: obj1.bill_add1 ?? "",
                Add2: obj1.bill_add2 ?? "",
                District: obj1.bill_district,
                State: obj1.bill_state,
                Town: obj1.bill_town.NAME,
                Email: obj1.cemail ?? "",
                Str: StrDataforESSR, //str data sub array
                accountId: "",
                Code: "",
                Name: obj1.name ?? "",
                LedgerId: "",
                LedgerName: "",
                RetailTag: "",
                Fax: "",
                Pincode: obj1.bill_zipcode,
                Active: "Y", // bind check status
                // Active: "Y", // bind check status
                ChkActive: false, // send false
                DistTag: auth.DistTag,
                Status: obj1.kyc_check ? "Y" : "N",
                SalesValue: "",
                TradeDiscount: obj1.trade_discount ?? "",
                AwaitedRILDetails: essrrlicustId, //AwaitedRILDetails id for essr
                AppPermission: obj1.app_per ? true : false,
                BillTitle: obj1.prefix ?? "",
                BillFirstname: obj1.cfname ?? "",
                BillMiddlename: obj1.cmname ?? "",
                BillLastname: obj1.clname ?? "",
                BillSerialNo: "1", // always 1
                BillAdd1: obj1.bill_add1 ?? "",
                BillAdd2: obj1.bill_add2 ?? "",
                BillEmail: obj1.cemail ?? "",
                BillFax: "", //send blank
                BillPhoneNo: obj1.cphoneno ?? "",
                BillOtherPhoneNo: obj1.cmobileno ?? "",
                BillGeogId: obj1.bill_town.GEOG_ID ?? "",
                BillTown: obj1.bill_town.NAME ?? "",
                BillDistrict: obj1.bill_district,
                BillState: obj1.bill_state,
                BillPinCode: obj1.bill_zipcode,
                BillStatus: "Y", // bind check status
                DSBillData: null,
                DSShipData: null,
                EInvApplicability: auth.EInvApplicability,
                EInvIRPUserId: auth.EInvIRPUserId,
                EInvIRPUserPassword: auth.EInvIRPUserPassword,
                EInvGSTNO: auth.EInvGSTNO,
                Strcustkyc: "",
                strship: StrShip,
                strPANDetails: panverifysuccess
                    ? [
                        obj1.name ?? "",
                        obj1.cfname ?? "",
                        obj1.cmname ?? "",
                        obj1.clname ?? "",
                        obj1.pan_no ?? "",
                        "V",
                        null,
                    ]
                    : null,
                _arrPANDtl: panverifysuccess ? storeVerifydata : null,
                Mobile: obj1.cmobileno ?? "",
                dgDistDiscount: null,
                strTrSuppTag: "N",
                strTrCustTag: "Y",
                strNtrCustTag: "N",
                strDefinedBy: "",
                strCustCount: "",
                strSuppCount: "",
                AlchemyName: "Not Applicable",
                RecordDefinedBy: "",
                AwaitedDNADetails: null,
                IsKYCApproved: "N",
                comments: obj1.comments,
                hdDist: getHDDistStatus ?? "",
                isILSHDUser: hdILScustomer,
            };
        } else if (customerType == "Gstvcust") {
            //edit ESSRRLI List Data
            editGSTCustdeatils = {
                SMSROWENTRY: [],
                CICode: auth.CICode,
                CustId: getGstcustId,
                urbanTag:rsechecked?"Y":"N",
                IsTCSApplicable: customerDetailsByIdGST.IsTCSApplicable,
                Compid: auth.CompId,
                CreditHold: obj1.credit_hold,
                CustGstin: obj1.gst_no ?? "",
                UniqueCode: obj1.unique_code ?? "",
                TINNO: obj1.tin_no ?? "",
                PAN_NO: obj1.pan_no ?? "",
                TaxForm: customerDetailsByIdGST.TaxForm,
                KYC: obj1.kyc_status ?? "",
                AADHARNO: obj1.caadhar ?? "",
                ImageUrl: "",
                CustPhoto: "",
                CustImage: [""],
                CustStore: "",
                StoreImage: [""],
                SpecialCode: "",
                Employee: `${obj1.employeeSelect.MASK_ID}~${obj1.employeeSelect.MASK_EMP_ID}~${obj1.employeeSelect.CODE}~${obj1.employeeSelect.NAME}`,
                Permission: obj1.app_per ? true : false,
                UserId: auth.UserId,
                PartyId: customerDetailsByIdGST.PartyId,
                maxOrderVal: obj1.max_order ?? "",
                Remarks: obj1.gst_no ?? "",
                GSTN_VERIFIED:
          customerDetailsById.GSTN_VERIFIED == "V" ? "Verified" : ("" ?? ""),
                CreditLimit: obj1.credit_limit ?? "",
                BillingIns: obj1.billing_inst ?? "",
                InvCopies: "0",
                CustdeliveryInst: obj1.delivery_inst ?? "",
                Priority: obj1.priority ?? "",
                Privilege: "",
                DocDiscount: obj1.trade_discount ?? "",
                TaxAreaId: obj1.tax_area.MASK_AREA_ID,
                TaxArea: `${obj1.tax_area.MASK_AREA_ID}~${obj1.tax_area.CODE}~${obj1.tax_area.NAME}`,
                PayTermId: obj1.payment_term.MASK_PAY_TERM_ID,
                PayTerm: `${obj1.payment_term.MASK_PAY_TERM_ID}~${obj1.payment_term.CODE}~${obj1.payment_term.NAME}`,
                PayModeId: obj1.payment_mode.MASK_MOP_ID,
                ModeOfPayment: `${obj1.payment_mode.MASK_MOP_ID}~${obj1.payment_mode.CODE}~${obj1.payment_mode.NAME}`,
                CurrencyId: customerDetailsByIdGST.CurrencyId ?? "",
                CurrencyName: customerDetailsByIdGST.CurrencyName ?? "",
                VanrtId: obj1?.van_route?.MASK_VAN_RT_ID ?? "",
                GSTNo: obj1.gst_no,
                SegId: customerDetailsByIdGST.SegId,
                DisplaySeq: "",
                Segment: customerDetailsByIdGST.Segment ?? "",
                SEG_NAME: customerDetailsByIdGST.Segment ?? "",
                AllchkmId: customerDetailsByIdGST.AllchkmId,
                SalesAreaId: customerDetailsByIdGST.SalesAreaId ?? "", // call api GetShipSalesArea
                MinOrderVal: obj1.min_order ?? "",
                Lat: obj1?.latitude?.toString() ?? "",
                Long: obj1?.longitude?.toString() ?? "",
                InsertUpdate: "2", //1 for insert 2 for update
                SalesexecutiveId: obj1.employeeSelect.MASK_EMP_ID,
                TransportChargeId: customerDetailsByIdGST.TransportChargeId ?? "",
                TransportCharges: obj1.transport_charges ?? "",
                CreationDate: creation_date,
                ExpiryDate: expiry_date,
                Compstate: customerDetailsByIdGST.Compstate,
                TaxPercentageRate: "", //customerDetailsById.TaxPercentageRate, //need to discuss ("")(api call gettcscust)
                InsertUpdateBill: "2",
                PrefferedDay: obj1.p_day_of_delivery.id,
                DayOfWeek: `${obj1.day_of_beat1.CODE}~${obj1.day_of_beat1.NAME}`,
                DeliveryDay1: customerDetailsByIdGST.DeliveryDay1 ?? "", //send blank
                DeliveryDay2: customerDetailsByIdGST.DeliveryDay1 ?? "", //send blank
                Frequency: `${obj1.beat_frequency.MASK_FREQUENCY_ID}~${obj1.beat_frequency.CODE}~${obj1.beat_frequency.NAME}`,
                BeatFrequency: obj1.beat_frequency.NAME ?? "",
                StartWeek: customerDetailsById.StartWeek ?? "",
                Beat2: customerDetailsById.Beat2 ?? "",
                ShipSerialNo: "1", // from UI which is missing
                ShipTitle: obj1.ship_title ?? "",
                ShipFirstname: obj1.fname ?? "",
                ShipMiddlename: obj1.mname ?? "",
                ShipLastname: obj1.lname ?? "",
                ShipEmail: obj1.ship_co_email ?? "",
                ShipFax: "",
                ShipToGSTN: obj1.ship_gst_no ?? "",
                ShipToName: obj1.ship_to_name ?? "",
                ShipSTD: "", // send blank
                ShipPhoneNo: obj1.phno ?? "",
                ShipOtherPhoneNo: obj1.mob ?? "",
                ShipAdd1: obj1.sadd1 ?? "",
                ShipAdd2: obj1.sadd2 ?? "",
                ShipState: obj1.ship_state,
                ShipTown: copyToShip
                    ? obj1.ship_town.NAME
                    : (obj1.ship_town.TOWN ?? ""),
                ShipDistrict: obj1.ship_district,
                ShipPinCode: obj1.ship_zipcode,
                SalesArea: customerDetailsByIdGST.SalesArea ?? "", // api call
                ShipGeogId: copyToShip
                    ? obj1.ship_town.GEOG_ID
                    : obj1.ship_town.MASK_GEOG_ID,
                ShipSalesExecutive: obj1.employeeSelect.NAME, // employee Name drop down
                ShipSalesExecutiveId: obj1.employeeSelect.MASK_EMP_ID, // employeeID drop down
                ShipStatus: "Y", // plesae add chechbox
                VanRt: obj1?.van_route?.NAME ?? "",
                InsertUpdateShip: "2", // 2 for update 1 for insert
                DTShippingOldData: null,
                TaxFormId: customerDetailsByIdGST.TaxFormId,
                Prefix: obj1.prefix ?? "",
                Firstname: obj1.cfname ?? "",
                MiddleName: obj1.cmname ?? "",
                Lastname: obj1.clname ?? "",
                StdCode: "",
                PhoneNo: obj1.cphoneno ?? "",
                OtherPhoneNo: obj1.cmobileno ?? "",
                Add1: obj1.bill_add1 ?? "",
                Add2: obj1.bill_add2 ?? "",
                District: obj1.bill_district,
                State: obj1.bill_state,
                Town: obj1.bill_town.NAME,
                Email: obj1.cemail ?? "",
                Str: customerDetailsByIdGST.Str, //str data sub array
                accountId: customerDetailsByIdGST.AccountId,
                Code: customerDetailsByIdGST.Code,
                Name: obj1.name ?? "",
                LedgerId: customerDetailsByIdGST.LedgerId,
                LedgerName: customerDetailsByIdGST.LedgerName,
                RetailTag: customerDetailsByIdGST.RetailTag,
                Fax: "",
                Pincode: obj1.bill_zipcode,
                Active: "Y", // bind check status
                // Active: "Y", // bind check status
                ChkActive: false, // send false
                DistTag: auth.DistTag,
                Status: obj1.kyc_check ? "Y" : "N",
                SalesValue: "",
                TradeDiscount: obj1.trade_discount ?? "",
                AwaitedRILDetails: null, //AwaitedRILDetails id for essr
                AppPermission: obj1.app_per ? true : false,
                BillTitle: obj1.prefix ?? "",
                BillFirstname: obj1.cfname ?? "",
                BillMiddlename: obj1.cmname ?? "",
                BillLastname: obj1.clname ?? "",
                BillSerialNo: "1", // always 1
                BillAdd1: obj1.bill_add1 ?? "",
                BillAdd2: obj1.bill_add2 ?? "",
                BillEmail: obj1.cemail ?? "",
                BillFax: "", //send blank
                BillPhoneNo: obj1.cphoneno ?? "",
                BillOtherPhoneNo: obj1.cmobileno ?? "",
                BillGeogId: obj1.bill_town.GEOG_ID ?? "",
                BillTown: obj1.bill_town.NAME ?? "",
                BillDistrict: obj1.bill_district,
                BillState: obj1.bill_state,
                BillPinCode: obj1.bill_zipcode,
                BillStatus: "Y", // bind check status
                DSBillData: null,
                DSShipData: null,
                EInvApplicability: auth.EInvApplicability,
                EInvIRPUserId: auth.EInvIRPUserId,
                EInvIRPUserPassword: auth.EInvIRPUserPassword,
                EInvGSTNO: auth.EInvGSTNO,
                Strcustkyc: "",
                strship: customerDetailsByIdGST.strship ?? "",
                strPANDetails: customerDetailsById.strPANDetails,
                _arrPANDtl: panverifysuccess ? storeVerifydata : null,
                Mobile: obj1.cmobileno ?? "",
                dgDistDiscount: null,
                strTrSuppTag: customerDetailsByIdGST.strTrSuppTag ?? "",
                strTrCustTag: customerDetailsByIdGST.strTrCustTag ?? "",
                strNtrCustTag: customerDetailsByIdGST.strNtrCustTag ?? "",
                strDefinedBy: customerDetailsByIdGST.strDefinedBy ?? "",
                strCustCount: customerDetailsByIdGST.strCustCount ?? "",
                strSuppCount: customerDetailsByIdGST.strSuppCount ?? "",
                AlchemyName: customerDetailsByIdGST.AlchemyName ?? "",
                RecordDefinedBy: customerDetailsByIdGST.RecordDefinedBy ?? "",
                AwaitedDNADetails: null,
                IsKYCApproved: "N",
                comments: obj1.comments,
                hdDist: getHDDistStatus ?? "",
                isILSHDUser: hdILScustomer,
                mobileExistCustDetail:
          ismobcustid == "Y" ? gstcustdetailsseparated : null,
                gstExistCustDetail: ismobcustid == "N" ? gstcustdetailsseparated : null,
            };
        } else {
            //edit DNA List Data
            const StrDataforDNA = [
                "G_BIGS_NA-2|G",
                "", //currency ID
                obj1.payment_mode.MASK_MOP_ID ?? "",
                obj1.payment_term.MASK_PAY_TERM_ID ?? "",
                shipSalesArea ?? "",
                "", //SalesexecutiveId
                manualSegmentEnterBtn
                    ? segmentValue.SBSD_ID
                    : dnaCustomerDetails.SubSegmentID,
                obj1.tax_area.MASK_AREA_ID,
                "", //TaxFormId
                // "711401000110001", //change on 19/03/2025 as per Arijit da
                obj1?.van_route?.MASK_VAN_RT_ID ?? "",
                "", //TransportChargeId
                "Y",
                expiry_date,
                obj1.trade_discount ?? "",
                obj1.credit_hold ? "Y" : "N",
                obj1.credit_limit ?? "",
                obj1.max_order ?? "",
                obj1.min_order ?? "",
                obj1.invoice_copy ?? "",
                obj1.delivery_inst ?? "",
                obj1.billing_inst ?? "",
                obj1.gst_no ?? "",
                "", // doubt
                "", // doubt
                "", //doubt
                obj1.priority ?? "",
                "",
                obj1.prefix ?? "",
                obj1.cfname ?? "",
                obj1.cmname ?? "",
                obj1.clname ?? "",
                "", //STD code
                obj1.cphoneno ?? "",
                obj1.cmobileno ?? "",
                obj1.bill_add1 ?? "",
                obj1.bill_add2 ?? "",
                obj1.bill_town.NAME,
                obj1.tin_no ?? "",
                obj1.cemail ?? "",
            ];

            editDNACutomerdeatils = {
                SMSROWENTRY: [],
                CICode: auth.CICode,
                CustId: "",
                urbanTag:rsechecked?"Y":"N",
                IsTCSApplicable: "",
                Compid: auth.CompId,
                CreditHold: obj1.credit_hold,
                CustGstin: obj1.gst_no ?? "",
                UniqueCode: obj1.unique_code ?? "",
                TINNO: obj1.tin_no ?? "",
                PAN_NO: obj1.pan_no ?? "",
                TaxForm: "",
                KYC: obj1.kyc_status ?? "",
                AADHARNO: obj1.caadhar ?? "",
                ImageUrl: "",
                CustPhoto: "",
                CustImage: [""],
                CustStore: "",
                StoreImage: [""],
                SpecialCode: "",
                Employee: `${obj1.employeeSelect.MASK_ID}~${obj1.employeeSelect.MASK_EMP_ID}~${obj1.employeeSelect.CODE}~${obj1.employeeSelect.NAME}`,
                Permission: obj1.app_per ? true : false,
                UserId: auth.UserId,
                PartyId: "",
                maxOrderVal: obj1.max_order ?? "",
                Remarks: obj1.gst_no ?? "",
                CreditLimit: obj1.credit_limit ?? "",
                BillingIns: obj1.billing_inst ?? "",
                InvCopies: "0",
                CustdeliveryInst: obj1.delivery_inst ?? "",
                Priority: obj1.priority ?? "",
                Privilege: "",
                DocDiscount: obj1.trade_discount ?? "",
                TaxAreaId: obj1.tax_area.MASK_AREA_ID,
                TaxArea: `${obj1.tax_area.MASK_AREA_ID}~${obj1.tax_area.CODE}~${obj1.tax_area.NAME}`,
                PayTermId: obj1.payment_term.MASK_PAY_TERM_ID,
                PayTerm: `${obj1.payment_term.MASK_PAY_TERM_ID}~${obj1.payment_term.CODE}~${obj1.payment_term.NAME}`,
                PayModeId: obj1.payment_mode.MASK_MOP_ID,
                ModeOfPayment: `${obj1.payment_mode.MASK_MOP_ID}~${obj1.payment_mode.CODE}~${obj1.payment_mode.NAME}`,
                CurrencyId: "",
                CurrencyName: "",
                VanrtId: obj1?.van_route?.MASK_VAN_RT_ID ?? "",
                GSTNo: obj1.gst_no ?? "",
                SegId: manualSegmentEnterBtn
                    ? segmentValue.SBSD_ID
                    : dnaCustomerDetails.SubSegmentID,
                DisplaySeq: "",
                Segment: manualSegmentEnterBtn
                    ? segmentValue.SEG_DESC
                    : dnaCustomerDetails.SubSegmentDesc,
                SEG_NAME: manualSegmentEnterBtn
                    ? segmentValue.SEG_DESC
                    : dnaCustomerDetails.SubSegmentDesc,
                AllchkmId: "G_BIGS_NA-2|G",
                SalesAreaId: shipSalesArea ?? "", // call api GetShipSalesArea
                MinOrderVal: obj1.min_order ?? "",
                Lat: obj1?.latitude?.toString() ?? "",
                Long: obj1?.longitude?.toString() ?? "",
                InsertUpdate: "1", //1 for insert 2 for update
                SalesexecutiveId: "",
                TransportChargeId: "",
                TransportCharges: obj1.transport_charges ?? "",
                CreationDate: creation_date,
                ExpiryDate: expiry_date,
                Compstate: compState ?? "",
                TaxPercentageRate: "", //customerDetailsById.TaxPercentageRate, //need to discuss ("")(api call gettcscust)
                InsertUpdateBill: "1",
                PrefferedDay: obj1.p_day_of_delivery.id,
                DayOfWeek: `${obj1.day_of_beat1.CODE}~${obj1.day_of_beat1.NAME}`,
                DeliveryDay1: "", //send blank
                DeliveryDay2: "", //send blank
                Frequency: `${obj1.beat_frequency.MASK_FREQUENCY_ID}~${obj1.beat_frequency.CODE}~${obj1.beat_frequency.NAME}`,
                BeatFrequency: obj1.beat_frequency.NAME,
                StartWeek: "",
                Beat2: "",
                ShipSerialNo: "1", // from UI which is missing
                ShipTitle: obj1.ship_title ?? "",
                ShipFirstname: obj1.fname ?? "",
                ShipMiddlename: obj1.mname ?? "",
                ShipLastname: obj1.lname ?? "",
                ShipEmail: obj1.ship_co_email ?? "",
                ShipFax: "",
                ShipToGSTN: obj1.ship_gst_no ?? "",
                ShipToName: obj1.ship_to_name ?? "",
                ShipSTD: "", // send blank
                ShipPhoneNo: obj1.phno ?? "",
                ShipOtherPhoneNo: obj1.mob ?? "",
                ShipAdd1: obj1.sadd1 ?? "",
                ShipAdd2: obj1.sadd2 ?? "",
                ShipState: obj1.ship_state ?? "",
                ShipTown: copyToShip
                    ? obj1.ship_town.NAME
                    : (obj1.ship_town.TOWN ?? ""),
                ShipDistrict: obj1.ship_district ?? "",
                ShipPinCode: obj1.ship_zipcode ?? "",
                SalesArea: shipSalesArea, // api call
                ShipGeogId: copyToShip
                    ? obj1.ship_town.GEOG_ID
                    : obj1.ship_town.MASK_GEOG_ID,
                ShipSalesExecutive: obj1.employeeSelect.NAME ?? "", // employee Name drop down
                ShipSalesExecutiveId: obj1.employeeSelect.MASK_EMP_ID ?? "", // employeeID drop down
                ShipStatus: "Y", // plesae add chechbox
                // VanRt: "DEFAULT VT",
                VanRt: obj1?.van_route?.NAME ?? "",
                InsertUpdateShip: "1", // 2 for update 1 for insert
                DTShippingOldData: null,
                TaxFormId: "",
                Prefix: obj1.prefix ?? "",
                Firstname: obj1.cfname ?? "",
                MiddleName: obj1.cmname ?? "",
                Lastname: obj1.clname ?? "",
                StdCode: "",
                PhoneNo: obj1.cphoneno ?? "",
                OtherPhoneNo: obj1.cmobileno ?? "",
                Add1: obj1.bill_add1 ?? "",
                Add2: obj1.bill_add2 ?? "",
                District: obj1.bill_district,
                State: obj1.bill_state,
                Town: obj1.bill_town.NAME ?? "",
                Email: obj1.cemail ?? "",
                Str: StrDataforDNA, //str data sub array
                accountId: "",
                Code: "",
                Name: obj1.name ?? "",
                LedgerId: "",
                LedgerName: "",
                RetailTag: "",
                Fax: "",
                Pincode: obj1.bill_zipcode ?? "",
                Active: "Y", // bind check status
                // Active: "Y", // bind check status
                ChkActive: false, // send false
                DistTag: auth.DistTag,
                Status: obj1.kyc_check ? "Y" : "N",
                SalesValue: "",
                TradeDiscount: obj1.trade_discount ?? "",
                AwaitedRILDetails: null,
                AppPermission: obj1.app_per ? true : false,
                BillTitle: obj1.prefix ?? "",
                BillFirstname: obj1.cfname ?? "",
                BillMiddlename: obj1.cmname ?? "",
                BillLastname: obj1.clname ?? "",
                BillSerialNo: "1", // always 1
                BillAdd1: obj1.bill_add1 ?? "",
                BillAdd2: obj1.bill_add2 ?? "",
                BillEmail: obj1.cemail ?? "",
                BillFax: "", //send blank
                BillPhoneNo: obj1.cphoneno ?? "",
                BillOtherPhoneNo: obj1.cmobileno ?? "",
                BillGeogId: obj1.bill_town.GEOG_ID ?? "",
                BillTown: obj1.bill_town.NAME ?? "",
                BillDistrict: obj1.bill_district ?? "",
                BillState: obj1.bill_state ?? "",
                BillPinCode: obj1.bill_zipcode ?? "",
                BillStatus: "Y", // bind check status
                DSBillData: null,
                DSShipData: null,
                EInvApplicability: auth.EInvApplicability,
                EInvIRPUserId: auth.EInvIRPUserId,
                EInvIRPUserPassword: auth.EInvIRPUserPassword,
                EInvGSTNO: auth.EInvGSTNO,
                Strcustkyc: "",
                strship: StrShip,
                Mobile: obj1.cmobileno ?? "",
                strPANDetails: panverifysuccess
                    ? [
                        obj1.name ?? "",
                        obj1.cfname ?? "",
                        obj1.cmname ?? "",
                        obj1.clname ?? "",
                        obj1.pan_no ?? "",
                        "V",
                        null,
                    ]
                    : null,
                _arrPANDtl: panverifysuccess ? storeVerifydata : null,
                dgDistDiscount: null,
                strTrSuppTag: "N",
                strTrCustTag: "Y",
                strNtrCustTag: "N",
                strDefinedBy: "",
                strCustCount: "",
                strSuppCount: "",
                AlchemyName: "Not Applicable",
                RecordDefinedBy: "",
                AwaitedDNADetails: [
                    dnaCustomerDetails.DNAID.toString(),
                    dnaCustomerDetails.OutletName,
                    dnaCustomerDetails.OwnerMobileNo,
                    dnaCustomerDetails.SubSegmentID,
                    dnaCustomerDetails.DSRID,
                    dnaCustomerDetails.BeatDay,
                    dnaCustomerDetails.SubSegmentDesc,
                    dnaCustomerDetails.DealerName,
                    dnaCustomerDetails.OwnerMobileNumberStatus ?? "",
                ], //dNA id
                IsKYCApproved: "N",
            };
        }

        let savepayload =
      customerType == "newcust"
          ? addnewSaveObj
          : customerType == "normal"
              ? editsaveobj
              : customerType == "RLIESSR"
                  ? editessrCustdeatils
                  : customerType == "Gstvcust"
                      ? editGSTCustdeatils
                      : editDNACutomerdeatils;
        console.log(customerType, "savepayload", savepayload);
        // setDisabledbtn(false);
        // return;

        try {
            const res = await Axios.post(
                saveCustomerMaster_URL,
                JSON.stringify(savepayload),
                {
                    headers: { "Content-Type": "application/json" },
                },
            );
            if (res.data) {
                setCustomerSaveUpdateLoader(false);

                if (res.data && newCustomerSave) {
                    toast.success(
                        `New Customer has been created Successfully with Customer code ${res.data.AccountId}`,
                        {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        },
                    );
                    setPartyCodeOnsave(res.data);
                    setCustomerSaveDisable(true);
                    setSegmtPopup(true);
                } else if (res.data && !newCustomerSave) {
                    toast.success(`${res.data.AccountId} has been updated successfully`, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                    setPartyCodeOnsave(res.data);
                    setSegmtPopup(true);
                    setCustomerSaveUpdateLoader(false);
                }
                nav("/masters/customermaster");
            }
        } catch (e) {
            if (e.response.data.Message == null) {
                toast.warning("something went wrong", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setCustomerSaveUpdateLoader(false);
            }
            toast.warning(`${e.response.data.Message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 4000,
            });
            setCustomerSaveUpdateLoader(false);
        } finally {
            setCustomerSaveUpdateLoader(false);
        }
    };

    const panverify = async () => {
    // console.log("formik", formik.values);

        if (formik.values?.name.trim() == "") {
            toast.warning("Customer Name cannot be left blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (formik.values?.cfname.trim() == "") {
            toast.warning("First Name cannot be left blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (formik.values?.clname.trim() == "") {
            toast.warning("Last Name cannot be left blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (formik.values?.pan_no.trim() == "") {
            toast.warning("PAN Number cannot be left blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        } else {
            const panRegex = new RegExp(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/);
            if (!panRegex.test(formik.values.pan_no)) {
                toast.warning("Invalid PAN Number", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                // errors.pan_no = "Invalid PAN Number";
                return;
            } else if (formik.values.pan_no.length > 10) {
                toast.warning("Invalid PAN Number length should be less than 10", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                // errors.pan_no = ;
                return;
            }
        }
        // console.log(addnewSaveObj);
        // if(customerType == "newcust"){
        let Payload = {
            ciCode: auth.CICode,
            custId: "",
            compid: auth.CompId,
            name: formik.values.name ?? "",
            firstName: formik.values.cfname ?? "",
            middleName: formik.values.cmname ?? "",
            lastName: formik.values.clname ?? "",
            pan: formik.values.pan_no ?? "",
            userId: auth.UserId,
            uniqueCode: "",
            strPanDetails: [
                formik.values.name ?? "",
                formik.values.cfname ?? "",
                formik.values.cmname ?? "",
                formik.values.clname ?? "",
                formik.values.pan_no ?? "",
                null,
                null,
            ],
            lstRes: [""],
        };
        let existingcustPayload = {
            ciCode: auth.CICode,
            custId: customerDetailsById.CustId,
            compid: auth.CompId,
            name: formik.values.name ?? "",
            firstName: formik.values.cfname ?? "",
            middleName: formik.values.cmname ?? "",
            lastName: formik.values.clname ?? "",
            pan: formik.values.pan_no ?? "",
            userId: auth.UserId,
            uniqueCode: formik.values.unique_code,
            strPanDetails: customerDetailsById.strPANDetails,
            lstRes: [""],
        };
        let finalpayload =
      customerType == "newcust" ||
      customerType == "RLIESSR" ||
      customerType == "DNA"
          ? Payload
          : existingcustPayload;

        console.log(finalpayload);
        // return;
        try {
            setLoaderpan(true);
            let panUrl = "CustomerMast/PanVerification";
            let postRes = await Axios.post(panUrl, JSON.stringify(finalpayload), {
                headers: { "Content-Type": "application/json" },
            });
            if (postRes.data.Status == "Success") {
                toast.success(`${postRes.data.Message}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setPanverifysuccess(true);
                setStoreVerifydata(postRes.data._arrPANDtl);
                setPandataverify(postRes.data.Data);
            }
        } catch (error) {
            toast.warn(`${error.response.data.Message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } finally {
            setLoaderpan(false);
        }
    };

    if (editCustMastLoader || customerSaveUpdateLoader) {
        return <Loader />;
    } else {
        return (
            <div>
                <main>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mx-1">
                                    <li className="breadcrumb-item">
                                        <Link to="/masters/customermaster">Customer Master</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                    Details
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="float-end">
                                <Link
                                    to={
                                        grid == "2"
                                            ? "/creditmanagement/documentadjustment/details"
                                            : grid !== "1"
                                                ? "/masters/customermaster"
                                                : "/masters/segmentreactivationchangerequest"
                                    }
                                >
                                    <button type="submit" className="btn btn-primary">
                                        <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                    Records
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* {loadinfdt?<Loader/>:null} */}

                    <div className="row CustomerTabs">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <form onSubmit={formik.handleSubmit}>
                                <Tabs
                                    defaultActiveKey={0}
                                    id="fill-tab-example"
                                    className="mt-2"
                                >
                                    <Tab eventKey={0} title="Basic Information">
                                        <Accordion defaultActiveKey="0">
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header x>
                                                    {formik.submitCount > 0 &&
                          (nameStatus ||
                            segStatus ||
                            pannoStatus ||
                            gstnoStatus ||
                            statuserror) ? (
                                                            <div style={{ color: "red" }}>
                              General Information <Fi.FiAlertTriangle />
                                                            </div>
                                                        ) : (
                                                            <>General Information</>
                                                        )}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="row">
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Code <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="code"
                                                                name="code"
                                                                class="form-control"
                                                                value={
                                                                    customerSaveDisable
                                                                        ? (formik.values.code =
                                        partyCodeOnSave.AccountId)
                                                                        : formik.values.code
                                                                }
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("code", e.target.value);
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid": isFormFieldInvalid("code"),
                                                                    },
                                                                    "form-control",
                                                                )}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Customer Name{" "}
                                                                <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="name"
                                                                name="name"
                                                                className="form-control"
                                                                value={formik.values.name}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={
                                                                    essrrliCuststatus ||
                                  kycfieldDisabled ||
                                  kycfieldDisabledforHDILS
                                                                }
                                                            />
                                                            {formik.touched.name && formik.errors.name && (
                                                                <small className="p-error">
                                                                    {formik.errors.name}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Unique Code <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="unique_code"
                                                                name="unique_code"
                                                                value={
                                                                    !newCustomerSave
                                                                        ? formik.values.unique_code
                                                                        : !manualTownEnter
                                                                            ? formik.values.unique_code
                                                                            : (formik.values.unique_code =
                                          newCutomerUniCode)
                                                                }
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "unique_code",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid":
                                      isFormFieldInvalid("unique_code"),
                                                                    },
                                                                    "form-control",
                                                                )}
                                                                disabled
                                                            />
                                                            {!uniqueCodeBtn &&
                                getFormErrorMessage("unique_code")}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Creation Date{" "}
                                                                <span className="mandatory">*</span>
                                                            </label>{" "}
                                                            <Calendar
                                                                inputId="creation_date"
                                                                name="creation_date"
                                                                value={
                                                                    newCustomerSave
                                                                        ? (formik.values.creation_date = new Date())
                                                                        : formik.values.creation_date
                                                                }
                                                                className={classNames({
                                                                    "p-invalid":
                                    isFormFieldInvalid("creation_date"),
                                                                })}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "creation_date",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                disabled
                                                                showIcon
                                                                dateFormat="dd/mm/yy"
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">Expiry Date</label>
                                                            <Calendar
                                                                inputId="expiry_date"
                                                                name="expiry_date"
                                                                value={formik.values.expiry_date}
                                                                className={classNames({
                                                                    "p-invalid":
                                    isFormFieldInvalid("expiry_date"),
                                                                })}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "expiry_date",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                minDate={new Date()}
                                                                showIcon
                                                                dateFormat="dd/mm/yy"
                                                            />
                                                            {getFormErrorMessage("expiry_date")}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Segment <span className="mandatory">*</span>
                                                            </label>
                                                            <div className="input-group">
                                                                <InputText
                                                                    id="segment"
                                                                    name="segment"
                                                                    placeholder="Select"
                                                                    // value={
                                                                    //   !newCustomerSave
                                                                    //     ? !manualSegmentEnterBtn
                                                                    //       ? (formik.values.segment =
                                                                    //           customerDetailsById.Segment)
                                                                    //       : (formik.values.segment =
                                                                    //           segmentValue.SEG_DESC)
                                                                    //     : !manualSegmentEnterBtn
                                                                    //     ? (formik.values.segment = "")
                                                                    //     : (formik.values.segment =
                                                                    //         segmentValue.SEG_DESC)
                                                                    // }
                                                                    value={
                                                                        newCustomerSave
                                                                            ? manualSegmentEnterBtn
                                                                                ? (formik.values.segment =
                                            segmentValue.SEG_DESC)
                                                                                : formik.values.segment
                                                                            : formik.values.segment
                                                                    }
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue(
                                                                            "segment",
                                                                            e.target.value,
                                                                        );
                                                                    }}
                                                                    className={classNames(
                                                                        {
                                                                            "p-invalid":
                                        isFormFieldInvalid("segment"),
                                                                        },
                                                                        "form-control",
                                                                    )}
                                                                    disabled
                                                                />
                                                                {!segmtPopup && (
                                                                    <div className="input-group-prepend">
                                                                        {" "}
                                                                        <span
                                                                            className="input-group-text ms-2"
                                                                            onClick={() => {
                                                                                setSegmentPopup(true);
                                                                                // setSegmentConfirmBtn(false);
                                                                            }}
                                                                        >
                                                                            <Fa.FaSearch />
                                                                        </span>{" "}
                                                                    </div>
                                                                )}{" "}
                                                            </div>

                                                            {!manualSegmentEnterBtn
                                                                ? getFormErrorMessage("segment")
                                                                : null}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="mt-3">
                                                                <label className="form-label">
                                  Status
                                                                    {hdILScustomer && (
                                                                        <span className="mandatory">*</span>
                                                                    )}
                                                                </label>
                                                                <InputSwitch
                                                                    className="switch-pos ms-2"
                                                                    id="kyc_check"
                                                                    name="kyc_check"
                                                                    checked={formik.values.kyc_check}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue("kyc_check", e.value);
                                                                    }}
                                                                />
                                                                {getFormErrorMessage("kyc_check")}
                                                            </div>
                                                        </div>
                            
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">KYC Status</label>
                                                            <InputText
                                                                id="kyc_status"
                                                                name="kyc_status"
                                                                class="form-control"
                                                                value={
                                                                    newCustomerSave
                                                                        ? segmentValue?.KYC_YN == "Y"
                                                                            ? "Under Approval"
                                                                            : "Not Applicable"
                                                                        : formik.values.kyc_status
                                                                }
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "kyc_status",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid":
                                      isFormFieldInvalid("kyc_status"),
                                                                    },
                                                                    "form-control",
                                                                )}
                                                                disabled
                                                            />
                                                        </div>

                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label d-block">
                                Geographical Coordinates
                                                            </label>

                                                            <InputText
                                                                id="latitude"
                                                                name="latitude"
                                                                style={{ width: "49%" }}
                                                                value={formik.values.latitude}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "latitude",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid": isFormFieldInvalid("latitude"),
                                                                    },
                                                                    "form-control d-inline me-1",
                                                                )}
                                                                disabled
                                                            />
                                                            <InputText
                                                                id="longitude"
                                                                style={{ width: "49%" }}
                                                                name="longitude"
                                                                value={formik.values.longitude}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "longitude",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid":
                                      isFormFieldInvalid("longitude"),
                                                                    },
                                                                    "form-control d-inline",
                                                                )}
                                                                disabled
                                                            />
                                                        </div>
                                                        {/* <div className="col-lg-3 col-md-6 col-sm-12">
                              <label className="form-label">TIN Number</label>
                              <InputText
                                id="tin_no"
                                name="tin_no"
                                className="form-control"
                                value={formik.values.tin_no}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "tin_no",
                                    e.target.value.toUpperCase()
                                  );
                                }}
                                onBlur={formik.handleBlur}
                              />
                              {formik.touched.tin_no &&
                                formik.errors.tin_no && (
                                  <small className="p-error">
                                    {formik.errors.tin_no}
                                  </small>
                                )}
                            </div> */}
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">PAN Number</label>
                                                            <div className="input-group">
                                                                <InputText
                                                                    id="pan_no"
                                                                    name="pan_no"
                                                                    className="form-control"
                                                                    value={formik.values.pan_no}
                                                                    maxLength={10}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue(
                                                                            "pan_no",
                                                                            e.target.value.toUpperCase(),
                                                                        );
                                                                    }}
                                                                    onBlur={formik.handleBlur}
                                                                    disabled={panverifysuccess}
                                                                />
                                                                <div className="input-group-prepend">
                                                                    {" "}
                                                                    <span
                                                                        className={`input-group-text ms-2 ${
                                                                            panverifysuccess || loaderpan
                                                                                ? "disabled-span"
                                                                                : ""
                                                                        }`}
                                                                        onClick={panverify}
                                                                        type="button"
                                                                        disabled={panverifysuccess || loaderpan}
                                                                    >
                                                                        {loaderpan ? "Verifying..." : "Verify"}{" "}
                                                                        {loaderpan ? (
                                                                            <span
                                                                                className="spinner-border spinner-border-sm"
                                                                                role="status"
                                                                                aria-hidden="true"
                                                                            ></span>
                                                                        ) : null}
                                                                    </span>{" "}
                                                                </div>
                                                            </div>

                                                            {formik.touched.pan_no &&
                                formik.errors.pan_no && (
                                                                <small className="p-error">
                                                                    {formik.errors.pan_no}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                GST Number{" "}
                                                                {gstrequedfield && (
                                                                    <span className="mandatory">*</span>
                                                                )}
                                                            </label>
                                                            <InputText
                                                                id="gst_no"
                                                                name="gst_no"
                                                                className="form-control"
                                                                value={formik.values.gst_no}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "gst_no",
                                                                        e.target.value.toUpperCase(),
                                                                    );
                                                                }}
                                                                onBlur={formik.handleBlur}
                                                                disabled={
                                                                    kycGSTfieldDisabledforHDILS ||
                                  ismobcustid == "N" ||
                                  gstverifiedtag
                                                                }
                                                            />
                                                            {formik.touched.gst_no &&
                                formik.errors.gst_no && (
                                                                <small className="p-error">
                                                                    {formik.errors.gst_no}
                                                                </small>
                                                            )}
                                                        </div>
                                                        {gstverifiedtag && (
                                                            <div className="col-lg-3 col-md-6 col-sm-12">
                                                                <label className="form-label">
                                  GST Number status{" "}
                                                                </label>
                                                                <InputText
                                                                    id="gst_no"
                                                                    name="gst_no"
                                                                    className="form-control"
                                                                    value="Verified"
                                                                    disabled
                                                                />
                                                            </div>
                                                        )}
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="mt-3">
                                                                <label className="form-label">
                                  APP Permission
                                                                </label>
                                                                <InputSwitch
                                                                    className="switch-pos ms-2"
                                                                    id="app_per"
                                                                    name="app_per"
                                                                    checked={formik.values.app_per}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue("app_per", e.value);
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                           
                                                        {showTCSdropdown && (
                                                            <div className="col-lg-3 col-md-6 col-sm-12">
                                                                <div className="mt-3">
                                                                    <label className="form-label">
                                    TCS Applicability
                                                                    </label>
                                                                    <Dropdown
                                                                        inputId="tcsapp"
                                                                        name="tcsapp"
                                                                        options={tcsDropDownlist}
                                                                        itemTemplate={tcsDropDownlistTemplate}
                                                                        optionLabel="TAX_PERCENTAGE"
                                                                        value={selectedTCS}
                                                                        onChange={(e) => setSelectedTCS(e.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {auth.DistTag !== "I" && <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="mt-3">
                                                                <label className="form-label">Urban RSE Customer</label>
                                                                <InputSwitch
                                                                    className="switch-pos ms-2"
                                                                    checked={rsechecked}
                                                                    disabled
                                                                    onChange={(e) => setRseChecked(e.value)}
                                                                />
                                                            </div>
                                                        </div>}
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header>
                                                    {formik.submitCount > 0 &&
                          (fnameStatus ||
                            lnameStatus ||
                            mobileStatus ||
                            prefixStatus ||
                            midnameStatus ||
                            phnoStatus ||
                            cemailStatus) ? (
                                                            <div style={{ color: "red" }}>
                              Contact Person <Fi.FiAlertTriangle />
                                                            </div>
                                                        ) : (
                                                            <>Contact Person</>
                                                        )}

                                                    {/* basic details */}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="row">
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">Prefix</label>
                                                            <InputText
                                                                id="prefix"
                                                                name="prefix"
                                                                className="form-control"
                                                                value={formik.values.prefix}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.prefix &&
                                formik.errors.prefix && (
                                                                <small className="p-error">
                                                                    {formik.errors.prefix}
                                                                </small>
                                                            )}
                                                        </div>

                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                First Name <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="cfname"
                                                                name="cfname"
                                                                className="form-control"
                                                                value={formik.values.cfname}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={
                                                                    kycfieldDisabled || kycfieldDisabledforHDILS
                                                                }
                                                            />
                                                            {formik.touched.cfname &&
                                formik.errors.cfname && (
                                                                <small className="p-error">
                                                                    {formik.errors.cfname}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Middle Name{" "}
                                                                {bsicmiddnamerequedfield && (
                                                                    <span className="mandatory">*</span>
                                                                )}
                                                            </label>
                                                            <InputText
                                                                id="cmname"
                                                                name="cmname"
                                                                className="form-control"
                                                                value={formik.values.cmname}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={kycfieldDisabledforHDILS}
                                                            />
                                                            {formik.touched.cmname &&
                                formik.errors.cmname && (
                                                                <small className="p-error">
                                                                    {formik.errors.cmname}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Last Name <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="clname"
                                                                name="clname"
                                                                className="form-control"
                                                                value={formik.values.clname}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={
                                                                    kycfieldDisabled || kycfieldDisabledforHDILS
                                                                }
                                                            />
                                                            {formik.touched.clname &&
                                formik.errors.clname && (
                                                                <small className="p-error">
                                                                    {formik.errors.clname}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">Phone Number</label>
                                                            <InputText
                                                                id="cphoneno"
                                                                name="cphoneno"
                                                                className="form-control"
                                                                value={formik.values.cphoneno}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.cphoneno &&
                                formik.errors.cphoneno && (
                                                                <small className="p-error">
                                                                    {formik.errors.cphoneno}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Mobile Number
                                                            </label>
                                                            <span className="mandatory">*</span>
                                                            <InputText
                                                                id="cmobileno"
                                                                name="cmobileno"
                                                                className="form-control"
                                                                value={formik.values.cmobileno}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={
                                                                    kycfieldDisabled ||
                                  kycfieldDisabledforHDILS ||
                                  dnaCustomerDetails?.OwnerMobileNumberStatus ==
                                    "V" ||
                                  mobverifiedtag
                                                                }
                                                                maxLength={10}
                                                            />
                                                            {formik.touched.cmobileno &&
                                formik.errors.cmobileno && (
                                                                <small className="p-error">
                                                                    {formik.errors.cmobileno}
                                                                </small>
                                                            )}
                                                        </div>
                                                        {(dnaCustomerDetails?.OwnerMobileNumberStatus ==
                              "V" ||
                              mobverifiedtag) && (
                                                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                                <label className="form-label">
                                  Mobile Number Status
                                                                </label>
                                                                <InputText
                                                                    id="cmobileno"
                                                                    name="cmobileno"
                                                                    className="form-control"
                                                                    value="Verified"
                                                                    disabled
                                                                />
                                                            </div>
                                                        )}

                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Company Email
                                                            </label>
                                                            <InputText
                                                                id="cemail"
                                                                name="cemail"
                                                                className="form-control"
                                                                value={formik.values.cemail}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.cemail &&
                                formik.errors.cemail && (
                                                                <small className="p-error">
                                                                    {formik.errors.cemail}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="mt-4">
                                                                <label className="form-label">
                                  Copy to Ship
                                                                </label>

                                                                <InputSwitch
                                                                    className="switch-pos ms-2"
                                                                    id="copy_to_ship_contact"
                                                                    name="copy_to_ship_contact"
                                                                    checked={formik.values.copy_to_ship_contact}
                                                                    onChange={handleCopyShipCont}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header>
                                                    {formik.submitCount > 0 &&
                          (address1Status || address2Status || townStatus) ? (
                                                            <div style={{ color: "red" }}>
                              Address <Fi.FiAlertTriangle />{" "}
                                                            </div>
                                                        ) : (
                                                            <>Address</>
                                                        )}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Address Line 1{" "}
                                                                <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="bill_add1"
                                                                name="bill_add1"
                                                                className="form-control"
                                                                value={formik.values.bill_add1}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={
                                                                    kycfieldDisabled || kycfieldDisabledforHDILS
                                                                }
                                                            />
                                                            {formik.touched.bill_add1 &&
                                formik.errors.bill_add1 && (
                                                                <small className="p-error">
                                                                    {formik.errors.bill_add1}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Address Line 2
                                                            </label>
                                                            <span className="mandatory">*</span>
                                                            <InputText
                                                                id="bill_add2"
                                                                name="bill_add2"
                                                                className="form-control"
                                                                value={formik.values.bill_add2}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={
                                                                    kycfieldDisabled || kycfieldDisabledforHDILS
                                                                }
                                                            />
                                                            {formik.touched.bill_add2 &&
                                formik.errors.bill_add2 && (
                                                                <small className="p-error">
                                                                    {formik.errors.bill_add2}
                                                                </small>
                                                            )}
                                                        </div>
                                                        {loader ? (
                                                            <>
                                                                <Loader />
                                                            </>
                                                        ) : (
                                                            <div className="col-lg-3 col-md-6 col-sm-12">
                                                                <label className="form-label">
                                                                    {/* Basic Information Town */}
                                  Town <span className="mandatory">*</span>
                                                                </label>
                                                                <div className="d-block">
                                                                    <AutoComplete
                                                                        field="TOWN_PIN"
                                                                        virtualScrollerOptions={{
                                                                            itemSize: 38,
                                                                        }}
                                                                        value={formik.values.bill_town}
                                                                        suggestions={townSuggestion}
                                                                        completeMethod={townFilter}
                                                                        onChange={(e) => {
                                                                            formik.setFieldValue(
                                                                                "bill_town",
                                                                                e.value,
                                                                            );
                                                                            townHandleChange(e);
                                                                        }}
                                                                        dropdown={true}
                                                                        itemTemplate={TownTemplate}
                                                                        showEmptyMessage={true}
                                                                        disabled={
                                                                            kycfieldDisabled ||
                                      essrrliCuststatus ||
                                      kycfieldDisabledforHDILS
                                                                        }
                                                                        forceSelection={true}
                                                                    />
                                                                    {getFormErrorMessage("bill_town")}
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">State</label>
                                                            <InputText
                                                                id="bill_state"
                                                                name="bill_state"
                                                                value={
                                                                    !manualTownEnter
                                                                        ? formik.values.bill_state
                                                                        : (formik.values.bill_state = billState)
                                                                }
                                                                onChange={(e) => {
                                                                    setManualTownEnter(false);
                                                                    formik.setFieldValue(
                                                                        "bill_state",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid":
                                      isFormFieldInvalid("bill_state"),
                                                                    },
                                                                    "form-control",
                                                                )}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">District</label>
                                                            <InputText
                                                                id="bill_district"
                                                                name="bill_district"
                                                                value={
                                                                    !manualTownEnter
                                                                        ? formik.values.bill_district
                                                                        : (formik.values.bill_district =
                                        billDistrict)
                                                                }
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "bill_district",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid":
                                      isFormFieldInvalid("bill_district"),
                                                                    },
                                                                    "form-control",
                                                                )}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Pin Code <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="bill_zipcode"
                                                                name="bill_zipcode"
                                                                value={
                                                                    !manualTownEnter
                                                                        ? formik.values.bill_zipcode
                                                                        : (formik.values.bill_zipcode = billZip)
                                                                }
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "bill_zipcode",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid":
                                      isFormFieldInvalid("bill_zipcode"),
                                                                    },
                                                                    "form-control",
                                                                )}
                                                                disabled
                                                            />
                                                            {getFormErrorMessage("bill_zipcode")}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="">
                                                                <label className="form-label">
                                  Copy to Ship
                                                                </label>

                                                                <InputSwitch
                                                                    className="switch-pos ms-2"
                                                                    id="copy_to_ship_address"
                                                                    name="copy_to_ship_address"
                                                                    checked={formik.values.copy_to_ship_address}
                                                                    onChange={handleCopyShipAdd}
                                                                    disabled={loadinfdt}
                                                                    // disabled={customerType=="RLIESSR"?true:false}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="3">
                                                <Accordion.Header>
                                                    {formik.submitCount > 0 &&
                          (creditHoldStatus ||
                            paymentTermStatus ||
                            paymentModeStatus ||
                            taxAreaStatus ||
                            tradeDiscStatus ||
                            creditlimStatus) ? (
                                                            <div style={{ color: "red" }}>
                              Financial Information <Fi.FiAlertTriangle />
                                                            </div>
                                                        ) : (
                                                            <>Financial Information</>
                                                        )}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="row">
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="mt-0">
                                                                <label className="form-label d-block">
                                  Credit Hold{" "}
                                                                    <span className="mandatory">*</span>
                                                                </label>
                                                                {radioBtns_credit_hold.map((btn, i) => {
                                                                    return (
                                                                        <div key={i} className="d-inline-flex pe-3">
                                                                            <RadioButton
                                                                                {...btn}
                                                                                checked={
                                                                                    formik.values.credit_hold ===
                                          btn.value
                                                                                }
                                                                                onChange={(e) => {
                                                                                    formik.setFieldValue(
                                                                                        "credit_hold",
                                                                                        e.value,
                                                                                    );
                                                                                }}
                                                                            />
                                                                            <label
                                                                                htmlFor={btn.inputId}
                                                                                className="ms-1"
                                                                            >
                                                                                {btn.name}
                                                                            </label>
                                                                        </div>
                                                                    );
                                                                })}
                                                                {getFormErrorMessage("credit_hold")}

                                                                <label></label>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Tax Form{" "}
                                                                {/* <span className="mandatory">*</span> */}
                                                            </label>{" "}
                                                            <InputText
                                                                inputId="tax_form"
                                                                name="tax_form"
                                                                value={formik.values.tax_form?.NAME}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Payment Term{" "}
                                                                <span className="mandatory">*</span>
                                                            </label>{" "}
                                                            <Dropdown
                                                                inputId="payment_term"
                                                                name="payment_term"
                                                                value={formik.values.payment_term}
                                                                options={paymentTerm}
                                                                itemTemplate={PayTermTaxAreaTemplate}
                                                                optionLabel="NAME"
                                                                placeholder="Select"
                                                                className={classNames({
                                                                    "p-invalid":
                                    isFormFieldInvalid("payment_term"),
                                                                })}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("payment_term", e.value);
                                                                }}
                                                            />
                                                            {getFormErrorMessage("payment_term")}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Tax Area <span className="mandatory">*</span>
                                                            </label>{" "}
                                                            <Dropdown
                                                                inputId="tax_area"
                                                                name="tax_area"
                                                                value={formik.values.tax_area}
                                                                options={taxArea}
                                                                itemTemplate={PayTermTaxAreaTemplate}
                                                                optionLabel="NAME"
                                                                placeholder="Select"
                                                                className={classNames({
                                                                    "p-invalid": isFormFieldInvalid("tax_area"),
                                                                })}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("tax_area", e.value);
                                                                }}
                                                            />
                                                            {getFormErrorMessage("tax_area")}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Payment Mode{" "}
                                                                <span className="mandatory">*</span>
                                                            </label>{" "}
                                                            <Dropdown
                                                                inputId="payment_mode"
                                                                name="payment_mode"
                                                                value={formik.values.payment_mode}
                                                                options={modeOfPayment}
                                                                optionLabel="NAME"
                                                                placeholder="Select"
                                                                className={classNames({
                                                                    "p-invalid":
                                    isFormFieldInvalid("payment_mode"),
                                                                })}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("payment_mode", e.value);
                                                                }}
                                                            />
                                                            {getFormErrorMessage("payment_mode")}
                                                        </div>
                                                        {/* <div className="col-lg-3 col-md-6 col-sm-12">
                                                                <label className="form-label">
                                                                    Invoice Copies{" "}
                                                                    <span className="mandatory">*</span>
                                                                </label>
                                                                <InputText
                                                                    id="invoice_copy"
                                                                    name="invoice_copy"
                                                                    value={formik.values.invoice_copy}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue(
                                                                            "invoice_copy",
                                                                            e.target.value
                                                                        );
                                                                    }}
                                                                    className={classNames(
                                                                        {
                                                                            "p-invalid":
                                                                                isFormFieldInvalid("invoice_copy"),
                                                                        },
                                                                        "form-control"
                                                                    )}
                                                                />
                                                                {getFormErrorMessage("invoice_copy")}


                                                            </div> */}
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Credit Limit (INR){" "}
                                                            </label>
                                                            <InputText
                                                                id="credit_limit"
                                                                name="credit_limit"
                                                                className="form-control"
                                                                value={formik.values.credit_limit}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.credit_limit &&
                                formik.errors.credit_limit && (
                                                                <small className="p-error">
                                                                    {formik.errors.credit_limit}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Trade Discount (%){" "}
                                                                <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="trade_discount"
                                                                name="trade_discount"
                                                                className="form-control"
                                                                value={formik.values.trade_discount}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.trade_discount &&
                                formik.errors.trade_discount && (
                                                                <small className="p-error">
                                                                    {formik.errors.trade_discount}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="4">
                                                <Accordion.Header>
                                                    {(formik.submitCount > 0 && preferedDayStatus) ||
                          delvinsStatus ||
                          minorderStatus ||
                          maxorderStatus ||
                          transchrgStatus ||
                          priortyStatus ||
                          billinsStatus ? (
                                                            <div style={{ color: "red" }}>
                              Delivery Instructions <Fi.FiAlertTriangle />
                                                            </div>
                                                        ) : (
                                                            <>Delivery Instructions</>
                                                        )}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="row">
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Min Order Value
                                                            </label>
                                                            <InputText
                                                                id="min_order"
                                                                name="min_order"
                                                                className="form-control"
                                                                value={formik.values.min_order}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.min_order &&
                                formik.errors.min_order && (
                                                                <small className="p-error">
                                                                    {formik.errors.min_order}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Max Order Value
                                                            </label>
                                                            <InputText
                                                                id="max_order"
                                                                name="max_order"
                                                                className="form-control"
                                                                value={formik.values.max_order}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.max_order &&
                                formik.errors.max_order && (
                                                                <small className="p-error">
                                                                    {formik.errors.max_order}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Transport Charges
                                                            </label>
                                                            <InputText
                                                                id="transport_charges"
                                                                name="transport_charges"
                                                                className="form-control"
                                                                value={formik.values.transport_charges}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.transport_charges &&
                                formik.errors.transport_charges && (
                                                                <small className="p-error">
                                                                    {formik.errors.transport_charges}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">Priority</label>
                                                            <InputText
                                                                id="priority"
                                                                name="priority"
                                                                className="form-control"
                                                                value={formik.values.priority}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.priority &&
                                formik.errors.priority && (
                                                                <small className="p-error">
                                                                    {formik.errors.priority}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Delivery Instruction
                                                            </label>
                                                            <InputText
                                                                id="delivery_inst"
                                                                name="delivery_inst"
                                                                className="form-control"
                                                                value={formik.values.delivery_inst}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.delivery_inst &&
                                formik.errors.delivery_inst && (
                                                                <small className="p-error">
                                                                    {formik.errors.delivery_inst}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Billing Instruction
                                                            </label>
                                                            <InputText
                                                                id="billing_inst"
                                                                name="billing_inst"
                                                                className="form-control"
                                                                value={formik.values.billing_inst}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.billing_inst &&
                                formik.errors.billing_inst && (
                                                                <small className="p-error">
                                                                    {formik.errors.billing_inst}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Preferred Delivery Day{" "}
                                                                <span className="mandatory">*</span>
                                                            </label>
                                                            <div className="flex justify-content-center">
                                                                {" "}
                                                                <Dropdown
                                                                    inputId="p_day_of_delivery"
                                                                    name="p_day_of_delivery"
                                                                    value={formik.values.p_day_of_delivery}
                                                                    options={preferedDay}
                                                                    optionLabel="name"
                                                                    placeholder="Select"
                                                                    className={classNames({
                                                                        "p-invalid":
                                      formik.touched.p_day_of_delivery &&
                                      formik.errors.p_day_of_delivery, // Show invalid class if touched and error
                                                                    })}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue(
                                                                            "p_day_of_delivery",
                                                                            e.value,
                                                                        );
                                                                    }}
                                                                    onBlur={() =>
                                                                        formik.setFieldTouched(
                                                                            "p_day_of_delivery",
                                                                            true,
                                                                        )
                                                                    } // Mark field as touched on blur
                                                                />
                                                                {formik.touched.p_day_of_delivery &&
                                  formik.errors.p_day_of_delivery && (
                                                                    <small className="p-error">
                                                                        {formik.errors.p_day_of_delivery}
                                                                    </small>
                                                                )}
                                                            </div>
                                                            {/* {getFormErrorMessage("p_day_of_delivery")} */}
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>

                                        <div className="Tab-box py-3">
                                            <div className="card p-3 shadow-sm">
                                                <h4>Sales Executive Details</h4>
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <label className="form-label">
                              Executive Name{" "}
                                                            <span className="mandatory">*</span>
                                                        </label>{" "}
                                                        <Dropdown
                                                            inputId="employeeSelect"
                                                            name="employeeSelect"
                                                            value={formik.values.employeeSelect}
                                                            options={employeeList}
                                                            optionLabel="NAME"
                                                            placeholder="Select Executive Name"
                                                            className={classNames({
                                                                "p-invalid":
                                  isFormFieldInvalid("employeeSelect"),
                                                            })}
                                                            onChange={(e) => {
                                                                formik.setFieldValue("employeeSelect", e.value);
                                                            }}
                                                        />
                                                        {getFormErrorMessage("employeeSelect")}
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <label className="form-label">
                              Visit Frequency{" "}
                                                            <span className="mandatory">*</span>
                                                        </label>{" "}
                                                        <Dropdown
                                                            inputId="beat_frequency"
                                                            name="beat_frequency"
                                                            value={formik.values.beat_frequency}
                                                            options={beatFrequency}
                                                            optionLabel="NAME"
                                                            placeholder="Select Visit Frequency"
                                                            className={classNames({
                                                                "p-invalid":
                                  isFormFieldInvalid("beat_frequency"),
                                                            })}
                                                            onChange={(e) => {
                                                                formik.setFieldValue("beat_frequency", e.value);
                                                            }}
                                                        />
                                                        {getFormErrorMessage("beat_frequency")}
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <label className="form-label">
                              Customer Visit Day{" "}
                                                            <span className="mandatory">*</span>
                                                        </label>{" "}
                                                        <Dropdown
                                                            inputId="day_of_beat1"
                                                            name="day_of_beat1"
                                                            value={formik.values.day_of_beat1}
                                                            options={dayOfWeek}
                                                            optionLabel="NAME"
                                                            placeholder="Select Customer Visit Day"
                                                            className={classNames({
                                                                "p-invalid": isFormFieldInvalid("day_of_beat1"),
                                                            })}
                                                            onChange={(e) => {
                                                                formik.setFieldValue("day_of_beat1", e.value);
                                                            }}
                                                        />
                                                        {getFormErrorMessage("day_of_beat1")}
                                                    </div>
                                                </div>
                                            </div>
                                            {commentssectionvsble && (
                                                <div className="card p-3 shadow-sm mt-3">
                                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                                        <label className="form-label">Comments</label>{" "}
                                                        <InputTextarea
                                                            id="comments"
                                                            name="comments"
                                                            className="form-control"
                                                            value={formik.values.comments}
                                                            onChange={formik.handleChange}
                                                            placeholder="Comments"
                                                            rows={5}
                                                            cols={30}
                                                            autoResize={false}
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Tab>
                                    <Tab eventKey={1} title="Shipping Address">
                                        <Accordion defaultActiveKey="0">
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>
                                                    {formik.submitCount > 0 &&
                          (address1Status1 ||
                            shipaddStatus ||
                            townStatus1 ||
                            shipgstStatus) ? (
                                                            <div style={{ color: "red" }}>
                              Address <Fi.FiAlertTriangle />
                                                            </div>
                                                        ) : (
                                                            <>Address</>
                                                        )}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="row">
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">Ship To Name</label>
                                                            <InputText
                                                                id="ship_to_name"
                                                                name="ship_to_name"
                                                                className="form-control"
                                                                value={formik.values.ship_to_name}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.ship_to_name &&
                                formik.errors.ship_to_name && (
                                                                <small className="p-error">
                                                                    {formik.errors.ship_to_name}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Address Line 1{" "}
                                                                <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="sadd1"
                                                                name="sadd1"
                                                                className="form-control"
                                                                value={formik.values.sadd1}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={kycfieldDisabledforHDILS}
                                                            />
                                                            {formik.touched.sadd1 && formik.errors.sadd1 && (
                                                                <small className="p-error">
                                                                    {formik.errors.sadd1}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Address Line 2{" "}
                                                                {hdILScustomer && (
                                                                    <span className="mandatory">*</span>
                                                                )}
                                                            </label>
                                                            <InputText
                                                                id="sadd2"
                                                                name="sadd2"
                                                                className="form-control"
                                                                value={formik.values.sadd2}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={kycfieldDisabledforHDILS}
                                                            />
                                                            {formik.touched.sadd2 && formik.errors.sadd2 && (
                                                                <small className="p-error">
                                                                    {formik.errors.sadd2}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Town <span className="mandatory">*</span>
                                                            </label>
                                                            <div className="d-block">
                                                                <AutoComplete
                                                                    field={
                                                                        formik.values.copy_to_ship_address
                                                                            ? "TOWN_PIN"
                                                                            : "TOWN_PIN_SHIP"
                                                                    }
                                                                    virtualScrollerOptions={{
                                                                        itemSize: 38,
                                                                    }}
                                                                    value={formik.values.ship_town}
                                                                    suggestions={shipTownSuggestion}
                                                                    completeMethod={shiptownFilter}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue(
                                                                            "copy_to_ship_address",
                                                                            false,
                                                                        );
                                                                        setCopyToShip(false);
                                                                        formik.setFieldValue("ship_town", e.value);
                                                                        shipTownHandleChange(e, 1);
                                                                    }}
                                                                    valueTemplate={(value) => {
                                                                        return value
                                                                            ? `${value.NAME} - ${value.PIN_CODE}`
                                                                            : "";
                                                                    }}
                                                                    dropdown={true}
                                                                    itemTemplate={ShipTownTemplate}
                                                                    showEmptyMessage={true}
                                                                    forceSelection={true}
                                                                    disabled={
                                                                        essrrliCuststatus ||
                                    kycfieldDisabledforHDILS
                                                                    }
                                                                />
                                                                {getFormErrorMessage("ship_town")}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">State</label>
                                                            <InputText
                                                                id="ship_state"
                                                                name="ship_state"
                                                                value={
                                                                    !manualShipTownEnter
                                                                        ? formik.values.ship_state
                                                                        : (formik.values.ship_state = shipState)
                                                                }
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "ship_state",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid":
                                      isFormFieldInvalid("ship_state"),
                                                                    },
                                                                    "form-control",
                                                                )}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">District</label>
                                                            <InputText
                                                                id="ship_district"
                                                                name="ship_district"
                                                                value={
                                                                    !manualShipTownEnter
                                                                        ? formik.values.ship_district
                                                                        : (formik.values.ship_district =
                                        shipDistrict)
                                                                }
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "ship_district",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid":
                                      isFormFieldInvalid("ship_district"),
                                                                    },
                                                                    "form-control",
                                                                )}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">Pin Code</label>
                                                            <InputText
                                                                id="ship_zipcode"
                                                                name="ship_zipcode"
                                                                value={
                                                                    !manualShipTownEnter
                                                                        ? formik.values.ship_zipcode
                                                                        : (formik.values.ship_zipcode = shipZip)
                                                                }
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(
                                                                        "ship_zipcode",
                                                                        e.target.value,
                                                                    );
                                                                }}
                                                                className={classNames(
                                                                    {
                                                                        "p-invalid":
                                      isFormFieldInvalid("ship_zipcode"),
                                                                    },
                                                                    "form-control",
                                                                )}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">Van Route</label>

                                                            <Dropdown
                                                                inputId="van_route"
                                                                name="van_route"
                                                                value={formik.values.van_route}
                                                                options={vanRoute}
                                                                optionLabel="NAME"
                                                                placeholder="Select"
                                                                className={classNames({
                                                                    "p-invalid": isFormFieldInvalid("van_route"),
                                                                })}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("van_route", e.value);
                                                                }}
                                                            />
                                                            {getFormErrorMessage("van_route")}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Ship GSTN No.
                                                            </label>
                                                            <InputText
                                                                id="ship_gst_no"
                                                                name="ship_gst_no"
                                                                className="form-control"
                                                                value={formik.values.ship_gst_no}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.ship_gst_no &&
                                formik.errors.ship_gst_no && (
                                                                <small className="p-error">
                                                                    {formik.errors.ship_gst_no}
                                                                </small>
                                                            )}
                                                        </div>
                                                        {/* <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="mt-3">
                                                                <label className="form-label">Active</label>
                                                                <InputSwitch
                                                                    className="switch-pos ms-2"
                                                                    id="active_check"
                                                                    name="active_check"
                                                                    checked={formik.values.active_check}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue(
                                                                            "active_check",
                                                                            e.value
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item>
                                                <Accordion.Header>
                                                    {formik.submitCount > 0 &&
                          (stitleStatus ||
                            fnameStatus1 ||
                            smidnameStatus ||
                            lnameStatus1 ||
                            sphnumStatus ||
                            mobileStatus1 ||
                            shipemailStatus) ? (
                                                            <div style={{ color: "red" }}>
                              Contact Person <Fi.FiAlertTriangle />
                                                            </div>
                                                        ) : (
                                                            <>Contact Person</>
                                                        )}
                                                </Accordion.Header>
                                                {/* shipping details */}
                                                <Accordion.Body>
                                                    <div className="row">
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">Prefix</label>
                                                            <InputText
                                                                id="ship_title"
                                                                name="ship_title"
                                                                className="form-control"
                                                                value={formik.values.ship_title}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.ship_title &&
                                formik.errors.ship_title && (
                                                                <small className="p-error">
                                                                    {formik.errors.ship_title}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                First Name <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="fname"
                                                                name="fname"
                                                                className="form-control"
                                                                value={formik.values.fname}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={kycfieldDisabledforHDILS}
                                                            />
                                                            {formik.touched.fname && formik.errors.fname && (
                                                                <small className="p-error">
                                                                    {formik.errors.fname}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Middle Name
                                                                {shipmiddnamerequedfield && (
                                                                    <span className="mandatory">*</span>
                                                                )}
                                                            </label>
                                                            <InputText
                                                                id="mname"
                                                                name="mname"
                                                                className="form-control"
                                                                value={formik.values.mname}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={kycfieldDisabledforHDILS}
                                                            />
                                                            {formik.touched.mname && formik.errors.mname && (
                                                                <small className="p-error">
                                                                    {formik.errors.mname}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">
                                Last Name <span className="mandatory">*</span>
                                                            </label>
                                                            <InputText
                                                                id="lname"
                                                                name="lname"
                                                                className="form-control"
                                                                value={formik.values.lname}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={kycfieldDisabledforHDILS}
                                                            />
                                                            {formik.touched.lname && formik.errors.lname && (
                                                                <small className="p-error">
                                                                    {formik.errors.lname}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                            <label className="form-label">Phone Number</label>
                                                            <InputText
                                                                id="phno"
                                                                name="phno"
                                                                className="form-control"
                                                                value={formik.values.phno}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.phno && formik.errors.phno && (
                                                                <small className="p-error">
                                                                    {formik.errors.phno}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Mobile Number
                                                            </label>
                                                            <span className="mandatory">*</span>
                                                            <InputText
                                                                id="mob"
                                                                name="mob"
                                                                className="form-control"
                                                                value={formik.values.mob}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={kycfieldDisabledforHDILS}
                                                                maxLength={10}
                                                            />
                                                            {formik.touched.mob && formik.errors.mob && (
                                                                <small className="p-error">
                                                                    {formik.errors.mob}
                                                                </small>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <label className="form-label">
                                Company Email
                                                            </label>
                                                            <InputText
                                                                id="ship_co_email"
                                                                name="ship_co_email"
                                                                className="form-control"
                                                                value={formik.values.ship_co_email}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.ship_co_email &&
                                formik.errors.ship_co_email && (
                                                                <small className="p-error">
                                                                    {formik.errors.ship_co_email}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </Tab>
                                    <Tab
                                        disabled={phototabdisle}
                                        eventKey={2}
                                        title="Photo Identity"
                                    >
                                        <div className="card p-3 m-3">
                                            <div className="row">
                                                <div className="col-lg-8 col-md-8 col-sm-12">
                                                    <h6>Customer Identity Photo</h6>
                                                    <div className="red-color font-sm">
                            *Size limit 500KB
                                                    </div>
                                                    <div className="red-color font-sm">
                            Customer Photo Identity should be from any of the
                            following(Pan Card, Voter Card)
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-12">
                                                    {photoUploadftCS && (
                                                        <div className="float-end">
                                                            <input
                                                                type="file"
                                                                id="cust_url"
                                                                name="cust_url"
                                                                className="file-upload"
                                                                onChange={handleFileChangecustphoto}
                                                            />
                                                            {formik.errors.cust_url &&
                                formik.touched.cust_url && (
                                                                <div style={{ color: "red" }}>
                                                                    {formik.errors.cust_url}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    {photoUploadndviewCS && (
                                                        <>
                                                            <div className="row d-flex justify-content-center align-items-center">
                                                                <div className="col-6">
                                                                    <div className="">
                                                                        <input
                                                                            type="file"
                                                                            id="cust_url"
                                                                            name="cust_url"
                                                                            className="file-upload"
                                                                            onChange={handleFileChangecustphoto}
                                                                        />
                                                                        {formik.errors.cust_url &&
                                      formik.touched.cust_url && (
                                                                            <div style={{ color: "red" }}>
                                                                                {formik.errors.cust_url}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <div className="float-end">
                                                                        <img
                                                                            className="placeholder-img"
                                                                            alt="InnoRise"
                                                                            src={
                                                                                formik.values.cust_viewurl === "" ||
                                        formik.values.cust_viewurl == null
                                                                                    ? require("../../Assets/Images/placeholder.jpg")
                                                                                    : formik.values.cust_viewurl
                                                                            }
                                                                        />
                                                                        <a
                                                                            className="enlarge d-block pt-1"
                                                                            onClick={() => setFullIdPopup(true)}
                                                                        >
                                      View Full Image
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {normalPhotoViewCS && (
                                                        <div className="float-end">
                                                            <img
                                                                className="placeholder-img"
                                                                alt="InnoRise"
                                                                src={
                                                                    formik.values.cust_viewurl === "" ||
                                  formik.values.cust_viewurl == null
                                                                        ? require("../../Assets/Images/placeholder.jpg")
                                                                        : formik.values.cust_viewurl
                                                                }
                                                            />
                                                            <a
                                                                className="enlarge d-block pt-1"
                                                                onClick={() => setFullIdPopup(true)}
                                                            >
                                View Full Image
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card p-3 m-3">
                                            <div className="row">
                                                <div className="col-lg-8 col-md-8 col-sm-12">
                                                    <h6>Customer Store Photo</h6>
                                                    <div className="red-color font-sm">
                            *Size limit 500KB
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-12">
                                                    {photoUploadftCS && (
                                                        <div className="float-end">
                                                            <input
                                                                type="file"
                                                                id="cust_store"
                                                                name="cust_store"
                                                                className="file-upload"
                                                                onChange={handleFileChangestorephoto}
                                                            />
                                                            {formik.errors.cust_store &&
                                formik.touched.cust_store && (
                                                                <div style={{ color: "red" }}>
                                                                    {formik.errors.cust_store}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    {photoUploadndviewCS && (
                                                        <>
                                                            <div className="row d-flex justify-content-center align-items-center">
                                                                <div className="col-6">
                                                                    <div className="">
                                                                        <input
                                                                            type="file"
                                                                            id="cust_store"
                                                                            name="cust_store"
                                                                            className="file-upload"
                                                                            onChange={handleFileChangestorephoto}
                                                                        />
                                                                        {formik.errors.cust_store &&
                                      formik.touched.cust_store && (
                                                                            <div style={{ color: "red" }}>
                                                                                {formik.errors.cust_store}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <div className="float-end">
                                                                        <img
                                                                            className="placeholder-img"
                                                                            alt="InnoRise"
                                                                            src={
                                                                                formik.values.cust_viewstore === "" ||
                                        formik.values.cust_viewstore == null
                                                                                    ? require("../../Assets/Images/placeholder.jpg")
                                                                                    : formik.values.cust_viewstore
                                                                            }
                                                                        />
                                                                        <a
                                                                            className="enlarge d-block pt-1"
                                                                            onClick={() => setFullcustimgpPopup(true)}
                                                                        >
                                      View Full Image
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {normalPhotoViewCS && (
                                                        <div className="float-end">
                                                            <img
                                                                className="placeholder-img"
                                                                alt="InnoRise"
                                                                src={
                                                                    formik.values.cust_viewstore === "" ||
                                  formik.values.cust_viewstore == null
                                                                        ? require("../../Assets/Images/placeholder.jpg")
                                                                        : formik.values.cust_viewstore
                                                                }
                                                            />
                                                            <a
                                                                className="enlarge d-block pt-1"
                                                                onClick={() => setFullcustimgpPopup(true)}
                                                            >
                                View Full Image
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                </Tabs>
                                {grid !== "1" &&
                  (newCustomerSave ? (
                      <div className="float-end">
                          <button
                              type="submit"
                              className="btn btn-primary mt-2"
                              disabled={
                                  kycStatus || customerSaveDisable || disabledbtn
                              }
                          >
                        Save
                          </button>
                      </div>
                  ) : (
                      <div className="float-end">
                          <button
                              type="submit"
                              className="btn btn-primary mt-2"
                              disabled={kycStatus || disabledbtn}
                          >
                        Save
                          </button>
                      </div>
                  ))}
                            </form>
                            <ToastContainer />
                        </div>
                    </div>
                </main>
                <SegmentModalNewCust stateProps={stateSegmentProps} />
                <Dialog
                    header="Customer Store Photo"
                    visible={fullcustimgpPopup}
                    style={{ width: "50vw" }}
                    onHide={() => setFullcustimgpPopup(false)}
                    draggable={false}
                    resizable={false}
                >
                    <div>
                        <img
                            className="fullImage"
                            alt="InnoRise"
                            src={
                                formik.values.cust_viewstore === "" ||
                formik.values.cust_viewstore == null
                                    ? require("../../Assets/Images/placeholder.jpg")
                                    : formik.values.cust_viewstore
                            }
                            width="100%"
                        />
                    </div>
                </Dialog>

                <Dialog
                    header="Customer Identity Photo"
                    visible={fulliIdPopup}
                    style={{ width: "50vw" }}
                    onHide={() => setFullIdPopup(false)}
                    draggable={false}
                    resizable={false}
                >
                    <div>
                        <img
                            className="fullImage"
                            alt="InnoRise"
                            src={
                                formik.values.cust_viewurl === "" ||
                formik.values.cust_viewurl == null
                                    ? require("../../Assets/Images/placeholder.jpg")
                                    : formik.values.cust_viewurl
                            }
                            width="100%"
                        />
                    </div>
                </Dialog>

                <Dialog
                    header="Phone Number Validation"
                    visible={phoneValidationPopUp}
                    style={{ width: "50vw" }}
                    draggable={false}
                    resizable={false}
                    closable={false}
                >
                    <div>
            This Phone Number already exists for a customer, do you still want
            to proceed?
                    </div>
                    <div className="float-end mt-4">
                        <button
                            type="button"
                            className="btn btn-primary me-3"
                            onClick={procedFurther}
                        >
              OK
                        </button>
                        <button
                            type="button"
                            className="btn btn-cancel-red"
                            onClick={() => setPhoneValidationPopUp(false)}
                        >
              Cancel
                        </button>
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default NewCustomer;
